var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _rect, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElegantGoldQr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2624_41551)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2624_41551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0996 0H0.0996094V40H40.0996V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2624_41551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0996 0H0.0996094V40H40.0996V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2624_41551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 6,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09961 4V5.6C2.09961 6.13043 2.31032 6.63914 2.6854 7.01421C3.06047 7.38929 3.56918 7.6 4.09961 7.6H5.69961C6.23004 7.6 6.73875 7.38929 7.11382 7.01421C7.4889 6.63914 7.69961 6.13043 7.69961 5.6V4C7.69961 3.46957 7.4889 2.96086 7.11382 2.58579C6.73875 2.21071 6.23004 2 5.69961 2H4.09961C3.56918 2 3.06047 2.21071 2.6854 2.58579C2.31032 2.96086 2.09961 3.46957 2.09961 4ZM4.09961 2.8H5.69961C6.01787 2.8 6.32309 2.92643 6.54814 3.15147C6.77318 3.37652 6.89961 3.68174 6.89961 4V5.6C6.89961 5.91826 6.77318 6.22348 6.54814 6.44853C6.32309 6.67357 6.01787 6.8 5.69961 6.8H4.09961C3.78135 6.8 3.47612 6.67357 3.25108 6.44853C3.02604 6.22348 2.89961 5.91826 2.89961 5.6V4C2.89961 3.68174 3.02604 3.37652 3.25108 3.15147C3.47612 2.92643 3.78135 2.8 4.09961 2.8Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2624_41551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69961 2H2.09961V7.6H7.69961V2Z",
    fill: "#AE984F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2624_41551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 4,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89922 6.0001C5.56196 6.0001 6.09922 5.46284 6.09922 4.8001C6.09922 4.13736 5.56196 3.6001 4.89922 3.6001C4.23648 3.6001 3.69922 4.13736 3.69922 4.8001C3.69922 5.46284 4.23648 6.0001 4.89922 6.0001Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2624_41551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09922 3.6001H3.69922V6.0001H6.09922V3.6001Z",
    fill: "#AE984F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2624_41551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 2,
    width: 7,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0996 2L34.4996 2C33.9692 2 33.4605 2.21071 33.0854 2.58579C32.7103 2.96086 32.4996 3.46957 32.4996 4V5.6C32.4996 6.13043 32.7103 6.63914 33.0854 7.01421C33.4605 7.38929 33.9692 7.6 34.4996 7.6H36.0996C36.63 7.6 37.1388 7.38929 37.5138 7.01421C37.8889 6.63914 38.0996 6.13043 38.0996 5.6V4C38.0996 3.46957 37.8889 2.96086 37.5138 2.58579C37.1388 2.21071 36.63 2 36.0996 2ZM37.2996 4V5.6C37.2996 5.91826 37.1732 6.22348 36.9481 6.44853C36.7231 6.67357 36.4179 6.8 36.0996 6.8H34.4996C34.1813 6.8 33.8761 6.67357 33.6511 6.44853C33.426 6.22348 33.2996 5.91826 33.2996 5.6V4C33.2996 3.68174 33.426 3.37651 33.6511 3.15147C33.8761 2.92643 34.1813 2.8 34.4996 2.8H36.0996C36.4179 2.8 36.7231 2.92643 36.9481 3.15147C37.1732 3.37651 37.2996 3.68174 37.2996 4Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2624_41551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1 2H32.5V7.6H38.1V2Z",
    fill: "#AE984F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2624_41551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 3,
    width: 3,
    height: 3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1 4.8001C34.1 5.46284 34.6373 6.0001 35.3 6.0001C35.9627 6.0001 36.5 5.46284 36.5 4.8001C36.5 4.13736 35.9627 3.6001 35.3 3.6001C34.6373 3.6001 34.1 4.13736 34.1 4.8001Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2624_41551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4996 3.6001H34.0996V6.0001H36.4996V3.6001Z",
    fill: "#AE984F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2624_41551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 32,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09961 38H5.69961C6.23004 38 6.73875 37.7893 7.11382 37.4142C7.48889 37.0391 7.69961 36.5304 7.69961 36V34.4C7.69961 33.8696 7.48889 33.3609 7.11382 32.9858C6.73875 32.6107 6.23004 32.4 5.69961 32.4H4.09961C3.56918 32.4 3.06047 32.6107 2.6854 32.9858C2.31032 33.3609 2.09961 33.8696 2.09961 34.4L2.09961 36C2.09961 36.5304 2.31032 37.0391 2.6854 37.4142C3.06047 37.7893 3.56918 38 4.09961 38ZM2.89961 36V34.4C2.89961 34.0817 3.02604 33.7765 3.25108 33.5515C3.47612 33.3264 3.78135 33.2 4.09961 33.2H5.69961C6.01787 33.2 6.32309 33.3264 6.54814 33.5515C6.77318 33.7765 6.89961 34.0817 6.89961 34.4V36C6.89961 36.3183 6.77318 36.6235 6.54814 36.8485C6.32309 37.0736 6.01787 37.2 5.69961 37.2H4.09961C3.78135 37.2 3.47612 37.0736 3.25108 36.8485C3.02604 36.6235 2.89961 36.3183 2.89961 36Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2624_41551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.69961 32.3999H2.09961V37.9999H7.69961V32.3999Z",
    fill: "#AE984F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2624_41551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 34,
    width: 4,
    height: 3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09922 35.1999C6.09922 34.5372 5.56196 33.9999 4.89922 33.9999C4.23648 33.9999 3.69922 34.5372 3.69922 35.1999C3.69922 35.8626 4.23648 36.3999 4.89922 36.3999C5.56196 36.3999 6.09922 35.8626 6.09922 35.1999Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2624_41551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09922 34H3.69922V36.4H6.09922V34Z",
    fill: "#AE984F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.833,
    y: 17.7334,
    width: 4.53333,
    height: 4.53333,
    fill: "url(#pattern0_2624_41551)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2624_41551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 37,
    height: 36
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 2.7998V1.9998H10.5004C10.3943 1.9998 10.2926 2.04195 10.2175 2.11696C10.1425 2.19198 10.1004 2.29372 10.1004 2.3998C10.1004 2.50589 10.1425 2.60763 10.2175 2.68265C10.2926 2.75766 10.3943 2.7998 10.5004 2.7998",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 2V2.8H11.7004V2.4C11.7004 2.29391 11.6582 2.19217 11.5832 2.11716C11.5082 2.04214 11.4065 2 11.3004 2",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 2.7998H14.0998V1.9998H13.6998C13.5937 1.9998 13.492 2.04195 13.417 2.11696C13.3419 2.19198 13.2998 2.29372 13.2998 2.3998",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 2V2.8H14.4996C14.6057 2.8 14.7074 2.75786 14.7825 2.68284C14.8575 2.60783 14.8996 2.50609 14.8996 2.4C14.8996 2.29391 14.8575 2.19217 14.7825 2.11716C14.7074 2.04214 14.6057 2 14.4996 2",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6998 2.8C17.9207 2.8 18.0998 2.62091 18.0998 2.4C18.0998 2.17909 17.9207 2 17.6998 2C17.4789 2 17.2998 2.17909 17.2998 2.4C17.2998 2.62091 17.4789 2.8 17.6998 2.8Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 2.7998H20.5002V1.9998H20.1002C19.9941 1.9998 19.8924 2.04195 19.8174 2.11696C19.7423 2.19198 19.7002 2.29372 19.7002 2.3998",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 2V2.8H21.3V2.4C21.3 2.29391 21.2579 2.19217 21.1828 2.11716C21.1078 2.04214 21.0061 2 20.9 2",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 2.7998V1.9998H22.5004C22.3943 1.9998 22.2926 2.04195 22.2175 2.11696C22.1425 2.19198 22.1004 2.29372 22.1004 2.3998C22.1004 2.50589 22.1425 2.60763 22.2175 2.68265C22.2926 2.75766 22.3943 2.7998 22.5004 2.7998",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 2V2.8H23.3004C23.4065 2.8 23.5082 2.75786 23.5832 2.68284C23.6582 2.60783 23.7004 2.50609 23.7004 2.4C23.7004 2.29391 23.6582 2.19217 23.5832 2.11716C23.5082 2.04214 23.4065 2 23.3004 2",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 2.7998H26.0998V1.9998H25.6998C25.5937 1.9998 25.492 2.04195 25.417 2.11696C25.3419 2.19198 25.2998 2.29372 25.2998 2.3998",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 2V2.8H26.4996C26.6057 2.8 26.7074 2.75786 26.7825 2.68284C26.8575 2.60783 26.8996 2.50609 26.8996 2.4C26.8996 2.29391 26.8575 2.19217 26.7825 2.11716C26.7074 2.04214 26.6057 2 26.4996 2",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 2.7998H28.5002V2.3998C28.5002 2.29372 28.4581 2.19198 28.383 2.11696C28.308 2.04195 28.2063 1.9998 28.1002 1.9998C27.9941 1.9998 27.8924 2.04195 27.8174 2.11696C27.7423 2.19198 27.7002 2.29372 27.7002 2.3998",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3004 2.8C31.5213 2.8 31.7004 2.62091 31.7004 2.4C31.7004 2.17909 31.5213 2 31.3004 2C31.0795 2 30.9004 2.17909 30.9004 2.4C30.9004 2.62091 31.0795 2.8 31.3004 2.8Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 3.6001V2.8001H10.9002V3.2001C10.9002 3.30618 10.9423 3.40793 11.0174 3.48294C11.0924 3.55795 11.1941 3.6001 11.3002 3.6001",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 2.7998V3.5998H12.5002V3.1998C12.5002 3.09372 12.4581 2.99198 12.383 2.91696C12.308 2.84195 12.2063 2.7998 12.1002 2.7998",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 2.7998H13.2996V3.1998C13.2996 3.30589 13.3418 3.40763 13.4168 3.48265C13.4918 3.55766 13.5935 3.5998 13.6996 3.5998C13.8057 3.5998 13.9074 3.55766 13.9825 3.48265C14.0575 3.40763 14.0996 3.30589 14.0996 3.1998",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 3.6001H15.7004V3.2001C15.7004 3.09401 15.6582 2.99227 15.5832 2.91725C15.5082 2.84224 15.4065 2.8001 15.3004 2.8001C15.1943 2.8001 15.0926 2.84224 15.0175 2.91725C14.9425 2.99227 14.9004 3.09401 14.9004 3.2001",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 2.7998H19.7002V3.5998H20.5002V2.7998Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 2.7998H20.5V3.5998H21.3V2.7998Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1002 3.5998C24.3211 3.5998 24.5002 3.42072 24.5002 3.1998C24.5002 2.97889 24.3211 2.7998 24.1002 2.7998C23.8793 2.7998 23.7002 2.97889 23.7002 3.1998C23.7002 3.42072 23.8793 3.5998 24.1002 3.5998Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 2.7998H25.2998V3.5998H26.0998V2.7998Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 3.6001H27.7004V2.8001H27.3004C27.1943 2.8001 27.0926 2.84224 27.0175 2.91725C26.9425 2.99227 26.9004 3.09401 26.9004 3.2001",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 2.7998H27.7V3.5998H28.1C28.2061 3.5998 28.3078 3.55766 28.3828 3.48265C28.4579 3.40763 28.5 3.30589 28.5 3.1998",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 3.6001H30.8996V3.2001C30.8996 3.09401 30.8575 2.99227 30.7825 2.91725C30.7074 2.84224 30.6057 2.8001 30.4996 2.8001C30.3935 2.8001 30.2918 2.84224 30.2168 2.91725C30.1418 2.99227 30.0996 3.09401 30.0996 3.2001",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.3999H9.3V3.9999C9.3 3.89382 9.25786 3.79207 9.18284 3.71706C9.10783 3.64204 9.00609 3.5999 8.9 3.5999C8.79391 3.5999 8.69217 3.64204 8.61716 3.71706C8.54214 3.79207 8.5 3.89382 8.5 3.9999",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 4.4001C10.7205 4.4001 10.8996 4.22101 10.8996 4.0001C10.8996 3.77918 10.7205 3.6001 10.4996 3.6001C10.2787 3.6001 10.0996 3.77918 10.0996 4.0001C10.0996 4.22101 10.2787 4.4001 10.4996 4.4001Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.3999V3.5999H11.7V3.9999C11.7 4.10599 11.7421 4.20773 11.8172 4.28275C11.8922 4.35776 11.9939 4.3999 12.1 4.3999",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.6001V4.4001H13.3V4.0001C13.3 3.89401 13.2579 3.79227 13.1828 3.71725C13.1078 3.64224 13.0061 3.6001 12.9 3.6001",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 4.3999H14.8996V3.5999H14.4996C14.3935 3.5999 14.2918 3.64204 14.2168 3.71706C14.1418 3.79207 14.0996 3.89382 14.0996 3.9999",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 3.6001H14.9002V4.4001H15.3002C15.4063 4.4001 15.508 4.35796 15.583 4.28294C15.6581 4.20793 15.7002 4.10618 15.7002 4.0001",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6998 4.4001C17.9207 4.4001 18.0998 4.22101 18.0998 4.0001C18.0998 3.77918 17.9207 3.6001 17.6998 3.6001C17.4789 3.6001 17.2998 3.77918 17.2998 4.0001C17.2998 4.22101 17.4789 4.4001 17.6998 4.4001Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 4.3999H19.7004V3.5999H19.3004C19.1943 3.5999 19.0926 3.64204 19.0175 3.71706C18.9425 3.79207 18.9004 3.89382 18.9004 3.9999",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 3.6001H19.7002V4.4001H20.5002V3.6001Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 3.6001H20.5V4.4001H21.3V3.6001Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 3.6001V4.4001H22.0998V4.0001C22.0998 3.89401 22.0577 3.79227 21.9826 3.71725C21.9076 3.64224 21.8059 3.6001 21.6998 3.6001",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 4.3999H25.3V3.5999H24.9C24.7939 3.5999 24.6922 3.64204 24.6172 3.71706C24.5421 3.79207 24.5 3.89382 24.5 3.9999",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 3.6001H25.2998V4.4001H26.0998V3.6001Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 3.6001H26.0996V4.4001H26.8996V3.6001Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 3.6001H26.9004V4.4001H27.7004V3.6001Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 3.6001H30.0996V4.4001H30.8996V3.6001Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 5.2002V4.4002H8.4998V4.8002C8.4998 4.90628 8.54195 5.00802 8.61696 5.08304C8.69198 5.15805 8.79372 5.2002 8.8998 5.2002",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 4.3999V5.1999H9.6998C9.80589 5.1999 9.90763 5.15776 9.98265 5.08274C10.0577 5.00773 10.0998 4.90599 10.0998 4.7999C10.0998 4.69382 10.0577 4.59207 9.98265 4.51706C9.90763 4.44205 9.80589 4.3999 9.6998 4.3999",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 5.2002H11.7004V4.8002C11.7004 4.69411 11.6582 4.59237 11.5832 4.51735C11.5082 4.44234 11.4065 4.4002 11.3004 4.4002C11.1943 4.4002 11.0926 4.44234 11.0175 4.51735C10.9425 4.59237 10.9004 4.69411 10.9004 4.8002",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 4.3999H12.4998V4.7999C12.4998 4.90599 12.5419 5.00773 12.617 5.08275C12.692 5.15776 12.7937 5.1999 12.8998 5.1999C13.0059 5.1999 13.1076 5.15776 13.1826 5.08275C13.2577 5.00773 13.2998 4.90599 13.2998 4.7999",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 4.3999H14.1004V4.7999C14.1004 4.90599 14.1425 5.00773 14.2175 5.08275C14.2926 5.15776 14.3943 5.1999 14.5004 5.1999C14.6065 5.1999 14.7082 5.15776 14.7832 5.08275C14.8582 5.00773 14.9004 4.90599 14.9004 4.7999",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7004 4.3999H18.9004V5.1999H19.7004V4.3999Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 4.3999H20.5V5.1999H21.3V4.3999Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 4.3999H21.2998V5.1999H22.0998V4.3999Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8996 4.3999H22.0996V5.1999H22.8996V4.3999Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 4.3999V5.1999H23.7004V4.7999C23.7004 4.69382 23.6582 4.59207 23.5832 4.51706C23.5082 4.44205 23.4065 4.3999 23.3004 4.3999",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 5.2002V4.4002H24.4998V4.8002C24.4998 4.90628 24.5419 5.00802 24.617 5.08304C24.692 5.15805 24.7937 5.2002 24.8998 5.2002",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 4.3999H25.2998V5.1999H26.0998V4.3999Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 4.3999H26.0996V5.1999H26.8996V4.3999Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 4.3999H26.9002V5.1999H27.3002C27.4063 5.1999 27.508 5.15776 27.583 5.08275C27.6581 5.00773 27.7002 4.90599 27.7002 4.7999",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 5.2002H29.3V4.8002C29.3 4.69411 29.2579 4.59237 29.1828 4.51735C29.1078 4.44234 29.0061 4.4002 28.9 4.4002C28.7939 4.4002 28.6922 4.44234 28.6172 4.51735C28.5421 4.59237 28.5 4.69411 28.5 4.8002",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 4.3999H30.0996V5.1999H30.8996V4.3999Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 4.3999V5.1999H31.7004V4.7999C31.7004 4.69382 31.6582 4.59207 31.5832 4.51706C31.5082 4.44205 31.4065 4.3999 31.3004 4.3999",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 6V5.2H10.5004C10.3943 5.2 10.2926 5.24214 10.2175 5.31716C10.1425 5.39217 10.1004 5.49391 10.1004 5.6C10.1004 5.70609 10.1425 5.80783 10.2175 5.88284C10.2926 5.95786 10.3943 6 10.5004 6",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7004 5.2002H10.9004V6.0002H11.7004V5.2002Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 5.2002V6.0002H12.5002V5.6002C12.5002 5.49411 12.4581 5.39237 12.383 5.31735C12.308 5.24234 12.2063 5.2002 12.1002 5.2002",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 6H14.0998V5.6C14.0998 5.49391 14.0577 5.39217 13.9826 5.31716C13.9076 5.24214 13.8059 5.2 13.6998 5.2C13.5937 5.2 13.492 5.24214 13.417 5.31716C13.3419 5.39217 13.2998 5.49391 13.2998 5.6",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3004 6.0002C15.5213 6.0002 15.7004 5.82111 15.7004 5.6002C15.7004 5.37928 15.5213 5.2002 15.3004 5.2002C15.0795 5.2002 14.9004 5.37928 14.9004 5.6002C14.9004 5.82111 15.0795 6.0002 15.3004 6.0002Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 6V5.2H16.8998C16.7937 5.2 16.692 5.24214 16.617 5.31716C16.5419 5.39217 16.4998 5.49391 16.4998 5.6C16.4998 5.70609 16.5419 5.80783 16.617 5.88284C16.692 5.95786 16.7937 6 16.8998 6",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0998 5.2002H17.2998V6.0002H18.0998V5.2002Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 5.2002H18.0996V6.0002H18.8996V5.2002Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7004 5.2002H18.9004V6.0002H19.7004V5.2002Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 5.2002H19.7002V6.0002H20.5002V5.2002Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 5.2002H20.5V6.0002H21.3V5.2002Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 5.2002H21.2998V6.0002H22.0998V5.2002Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 6V5.2H22.9002V5.6C22.9002 5.70609 22.9423 5.80783 23.0174 5.88284C23.0924 5.95786 23.1941 6 23.3002 6",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 5.2002V6.0002H24.1002C24.2063 6.0002 24.308 5.95805 24.383 5.88304C24.4581 5.80802 24.5002 5.70628 24.5002 5.6002C24.5002 5.49411 24.4581 5.39237 24.383 5.31735C24.308 5.24234 24.2063 5.2002 24.1002 5.2002",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 6V5.2H25.2996V5.6C25.2996 5.70609 25.3418 5.80783 25.4168 5.88284C25.4918 5.95786 25.5935 6 25.6996 6",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 5.2002H26.1004V6.0002H26.5004C26.6065 6.0002 26.7082 5.95805 26.7832 5.88304C26.8582 5.80802 26.9004 5.70628 26.9004 5.6002",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 6V5.2H28.4998V5.6C28.4998 5.70609 28.5419 5.80783 28.617 5.88284C28.692 5.95786 28.7937 6 28.8998 6",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 5.2002H29.2998V6.0002H30.0998V5.2002Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 5.2002H30.0996V6.0002H30.8996V5.2002Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 5.2002H30.9002V6.0002H31.3002C31.4063 6.0002 31.508 5.95805 31.583 5.88304C31.6581 5.80802 31.7002 5.70628 31.7002 5.6002",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 6H11.7002V6.8H12.5002V6Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 6H12.5V6.8H13.3V6Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 6H13.2998V6.8H14.0998V6Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1002 6.8C16.3211 6.8 16.5002 6.62091 16.5002 6.4C16.5002 6.17909 16.3211 6 16.1002 6C15.8793 6 15.7002 6.17909 15.7002 6.4C15.7002 6.62091 15.8793 6.8 16.1002 6.8Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 6H18.0996V6.8H18.8996V6Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 6H21.2998V6.8H22.0998V6Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 6V6.8H22.4996C22.6057 6.8 22.7074 6.75786 22.7825 6.68284C22.8575 6.60783 22.8996 6.50609 22.8996 6.4C22.8996 6.29391 22.8575 6.19217 22.7825 6.11716C22.7074 6.04214 22.6057 6 22.4996 6",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.7998H25.3V6.3998C25.3 6.29372 25.2579 6.19198 25.1828 6.11696C25.1078 6.04195 25.0061 5.9998 24.9 5.9998C24.7939 5.9998 24.6922 6.04195 24.6172 6.11696C24.5421 6.19198 24.5 6.29372 24.5 6.3998",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 6.7998V5.9998H27.3002C27.1941 5.9998 27.0924 6.04195 27.0174 6.11696C26.9423 6.19198 26.9002 6.29372 26.9002 6.3998C26.9002 6.50589 26.9423 6.60763 27.0174 6.68265C27.0924 6.75766 27.1941 6.7998 27.3002 6.7998",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 6V6.8H28.5002V6.4C28.5002 6.29391 28.4581 6.19217 28.383 6.11716C28.308 6.04214 28.2063 6 28.1002 6",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9 7.5998C9.12091 7.5998 9.3 7.42072 9.3 7.1998C9.3 6.97889 9.12091 6.7998 8.9 6.7998C8.67909 6.7998 8.5 6.97889 8.5 7.1998C8.5 7.42072 8.67909 7.5998 8.9 7.5998Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 7.6001H10.8996V7.2001C10.8996 7.09401 10.8575 6.99227 10.7825 6.91725C10.7074 6.84224 10.6057 6.8001 10.4996 6.8001C10.3935 6.8001 10.2918 6.84224 10.2168 6.91725C10.1418 6.99227 10.0996 7.09401 10.0996 7.2001",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 6.7998H11.7002V7.5998H12.5002V6.7998Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 6.7998H13.2998V7.5998H14.0998V6.7998Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3004 7.5998C15.5213 7.5998 15.7004 7.42072 15.7004 7.1998C15.7004 6.97889 15.5213 6.7998 15.3004 6.7998C15.0795 6.7998 14.9004 6.97889 14.9004 7.1998C14.9004 7.42072 15.0795 7.5998 15.3004 7.5998Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.6001H17.3V7.2001C17.3 7.09401 17.2579 6.99227 17.1828 6.91725C17.1078 6.84224 17.0061 6.8001 16.9 6.8001C16.7939 6.8001 16.6922 6.84224 16.6172 6.91725C16.5421 6.99227 16.5 7.09401 16.5 7.2001",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 6.7998H18.0996V7.5998H18.8996V6.7998Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1002 7.5998C20.3211 7.5998 20.5002 7.42072 20.5002 7.1998C20.5002 6.97889 20.3211 6.7998 20.1002 6.7998C19.8793 6.7998 19.7002 6.97889 19.7002 7.1998C19.7002 7.42072 19.8793 7.5998 20.1002 7.5998Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 6.7998H21.2998V7.5998H22.0998V6.7998Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 7.6001H23.7004V7.2001C23.7004 7.09401 23.6582 6.99227 23.5832 6.91725C23.5082 6.84224 23.4065 6.8001 23.3004 6.8001C23.1943 6.8001 23.0926 6.84224 23.0175 6.91725C22.9425 6.99227 22.9004 7.09401 22.9004 7.2001",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 6.7998H24.4998V7.1998C24.4998 7.30589 24.5419 7.40763 24.617 7.48265C24.692 7.55766 24.7937 7.5998 24.8998 7.5998C25.0059 7.5998 25.1076 7.55766 25.1826 7.48265C25.2577 7.40763 25.2998 7.30589 25.2998 7.1998",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 7.6001H26.8996V7.2001C26.8996 7.09401 26.8575 6.99227 26.7825 6.91725C26.7074 6.84224 26.6057 6.8001 26.4996 6.8001C26.3935 6.8001 26.2918 6.84224 26.2168 6.91725C26.1418 6.99227 26.0996 7.09401 26.0996 7.2001",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 6.7998H27.7002V7.5998H28.5002V6.7998Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 7.6001H30.0998V7.2001C30.0998 7.09401 30.0577 6.99227 29.9826 6.91725C29.9076 6.84224 29.8059 6.8001 29.6998 6.8001C29.5937 6.8001 29.492 6.84224 29.417 6.91725C29.3419 6.99227 29.2998 7.09401 29.2998 7.2001",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3004 7.5998C31.5213 7.5998 31.7004 7.42072 31.7004 7.1998C31.7004 6.97889 31.5213 6.7998 31.3004 6.7998C31.0795 6.7998 30.9004 6.97889 30.9004 7.1998C30.9004 7.42072 31.0795 7.5998 31.3004 7.5998Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 8.3999V7.5999H10.1004V7.9999C10.1004 8.10599 10.1425 8.20773 10.2175 8.28274C10.2926 8.35776 10.3943 8.3999 10.5004 8.3999",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7004 7.6001H10.9004V8.4001H11.7004V7.6001Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.6001H11.7V8.4001H12.1C12.2061 8.4001 12.3078 8.35796 12.3828 8.28294C12.4579 8.20793 12.5 8.10618 12.5 8.0001",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 7.6001H13.2996V8.0001C13.2996 8.10618 13.3418 8.20793 13.4168 8.28294C13.4918 8.35796 13.5935 8.4001 13.6996 8.4001C13.8057 8.4001 13.9074 8.35796 13.9825 8.28294C14.0575 8.20793 14.0996 8.10618 14.0996 8.0001",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.3999V7.5999H16.1C15.9939 7.5999 15.8922 7.64205 15.8172 7.71706C15.7421 7.79207 15.7 7.89382 15.7 7.9999C15.7 8.10599 15.7421 8.20773 15.8172 8.28274C15.8922 8.35776 15.9939 8.3999 16.1 8.3999",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 7.6001H16.4998V8.4001H16.8998C17.0059 8.4001 17.1076 8.35796 17.1826 8.28294C17.2577 8.20793 17.2998 8.10618 17.2998 8.0001",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 7.6001H18.0996V8.4001H18.8996V7.6001Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 7.6001H21.2998V8.4001H22.0998V7.6001Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 7.6001H22.9002V8.0001C22.9002 8.10618 22.9423 8.20793 23.0174 8.28294C23.0924 8.35796 23.1941 8.4001 23.3002 8.4001C23.4063 8.4001 23.508 8.35796 23.583 8.28294C23.6581 8.20793 23.7002 8.10618 23.7002 8.0001",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 8.3999V7.5999H25.6996C25.5935 7.5999 25.4918 7.64205 25.4168 7.71706C25.3418 7.79207 25.2996 7.89382 25.2996 7.9999C25.2996 8.10599 25.3418 8.20773 25.4168 8.28274C25.4918 8.35776 25.5935 8.3999 25.6996 8.3999",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 7.6001H26.0996V8.4001H26.8996V7.6001Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 7.6001H27.7V8.0001C27.7 8.10618 27.7421 8.20793 27.8172 8.28294C27.8922 8.35796 27.9939 8.4001 28.1 8.4001C28.2061 8.4001 28.3078 8.35796 28.3828 8.28294C28.4579 8.20793 28.5 8.10618 28.5 8.0001",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 7.6001H29.2998V8.4001H30.0998V7.6001Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 7.6001V8.4001H30.8996V8.0001C30.8996 7.89401 30.8575 7.79227 30.7825 7.71726C30.7074 7.64224 30.6057 7.6001 30.4996 7.6001",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 9.2002V8.4002H4.8998C4.79372 8.4002 4.69198 8.44234 4.61696 8.51735C4.54195 8.59237 4.4998 8.69411 4.4998 8.8002C4.4998 8.90628 4.54195 9.00802 4.61696 9.08304C4.69198 9.15805 4.79372 9.2002 4.8998 9.2002",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 8.3999V9.1999H6.0998V8.7999C6.0998 8.69382 6.05766 8.59207 5.98265 8.51706C5.90763 8.44205 5.80589 8.3999 5.6998 8.3999",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 9.2002V8.4002H7.3002C7.19411 8.4002 7.09237 8.44234 7.01735 8.51735C6.94234 8.59237 6.9002 8.69411 6.9002 8.8002C6.9002 8.90628 6.94234 9.00802 7.01735 9.08304C7.09237 9.15805 7.19411 9.2002 7.3002 9.2002",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 8.3999V9.1999H8.1002C8.20628 9.1999 8.30802 9.15776 8.38304 9.08275C8.45805 9.00773 8.5002 8.90599 8.5002 8.7999C8.5002 8.69382 8.45805 8.59207 8.38304 8.51706C8.30802 8.44205 8.20628 8.3999 8.1002 8.3999",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0996 9.2002V8.4002H17.6996C17.5935 8.4002 17.4918 8.44234 17.4168 8.51735C17.3418 8.59237 17.2996 8.69411 17.2996 8.8002C17.2996 8.90628 17.3418 9.00802 17.4168 9.08304C17.4918 9.15805 17.5935 9.2002 17.6996 9.2002",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 8.3999H18.0996V9.1999H18.8996V8.3999Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7004 8.3999H18.9004V9.1999H19.7004V8.3999Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 8.3999H19.7002V9.1999H20.5002V8.3999Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 8.3999H20.5V9.1999H21.3V8.3999Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 8.3999H21.2998V9.1999H22.0998V8.3999Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 8.3999V9.1999H22.8996V8.7999C22.8996 8.69382 22.8575 8.59207 22.7825 8.51706C22.7074 8.44205 22.6057 8.3999 22.4996 8.3999",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1002 9.1999C24.3211 9.1999 24.5002 9.02082 24.5002 8.7999C24.5002 8.57899 24.3211 8.3999 24.1002 8.3999C23.8793 8.3999 23.7002 8.57899 23.7002 8.7999C23.7002 9.02082 23.8793 9.1999 24.1002 9.1999Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 8.3999H26.0996V9.1999H26.8996V8.3999Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 8.3999V9.1999H27.7004V8.7999C27.7004 8.69382 27.6582 8.59207 27.5832 8.51706C27.5082 8.44205 27.4065 8.3999 27.3004 8.3999",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 8.3999H29.2998V9.1999H30.0998V8.3999Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 8.3999H30.0996V9.1999H30.8996V8.3999Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 8.3999V9.1999H31.7004V8.7999C31.7004 8.69382 31.6582 8.59207 31.5832 8.51706C31.5082 8.44205 31.4065 8.3999 31.3004 8.3999",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 9.2002H35.7004V8.4002H35.3004C35.1943 8.4002 35.0926 8.44234 35.0175 8.51735C34.9425 8.59237 34.9004 8.69411 34.9004 8.8002",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 8.3999V9.1999H36.1002C36.2063 9.1999 36.308 9.15776 36.383 9.08275C36.4581 9.00773 36.5002 8.90599 36.5002 8.7999C36.5002 8.69382 36.4581 8.59207 36.383 8.51706C36.308 8.44205 36.2063 8.3999 36.1002 8.3999",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 10V9.2H2.50039C2.3943 9.2 2.29256 9.24214 2.21755 9.31716C2.14253 9.39217 2.10039 9.49391 2.10039 9.6C2.10039 9.70609 2.14253 9.80783 2.21755 9.88284C2.29256 9.95786 2.3943 10 2.50039 10",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 9.2002V10.0002H3.30039C3.40648 10.0002 3.50822 9.95805 3.58323 9.88304C3.65825 9.80802 3.70039 9.70628 3.70039 9.6002C3.70039 9.49411 3.65825 9.39237 3.58323 9.31735C3.50822 9.24234 3.40648 9.2002 3.30039 9.2002",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 9.2002H5.29961V9.6002C5.29961 9.70628 5.34175 9.80802 5.41677 9.88304C5.49178 9.95805 5.59352 10.0002 5.69961 10.0002C5.8057 10.0002 5.90744 9.95805 5.98245 9.88304C6.05747 9.80802 6.09961 9.70628 6.09961 9.6002",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 10H10.8996V9.2H10.4996C10.3935 9.2 10.2918 9.24214 10.2168 9.31716C10.1418 9.39217 10.0996 9.49391 10.0996 9.6",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7004 9.2002H10.9004V10.0002H11.7004V9.2002Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 9.2002V10.0002H12.5002V9.6002C12.5002 9.49411 12.4581 9.39237 12.383 9.31735C12.308 9.24234 12.2063 9.2002 12.1002 9.2002",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 10H14.8996V9.2H14.4996C14.3935 9.2 14.2918 9.24214 14.2168 9.31716C14.1418 9.39217 14.0996 9.49391 14.0996 9.6",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 9.2002V10.0002H15.3004C15.4065 10.0002 15.5082 9.95805 15.5832 9.88304C15.6582 9.80802 15.7004 9.70628 15.7004 9.6002C15.7004 9.49411 15.6582 9.39237 15.5832 9.31735C15.5082 9.24234 15.4065 9.2002 15.3004 9.2002",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 9.2002H18.9002V9.6002C18.9002 9.70628 18.9423 9.80802 19.0174 9.88304C19.0924 9.95805 19.1941 10.0002 19.3002 10.0002C19.4063 10.0002 19.508 9.95805 19.583 9.88304C19.6581 9.80802 19.7002 9.70628 19.7002 9.6002",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8996 9.2002H22.0996V10.0002H22.8996V9.2002Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 9.2002V10.0002H23.7004V9.6002C23.7004 9.49411 23.6582 9.39237 23.5832 9.31735C23.5082 9.24234 23.4065 9.2002 23.3004 9.2002",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 10V9.2H26.1004V9.6C26.1004 9.70609 26.1425 9.80783 26.2175 9.88284C26.2926 9.95786 26.3943 10 26.5004 10",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 9.2002H26.9004V10.0002H27.7004V9.2002Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 9.2002H27.7002V10.0002H28.5002V9.2002Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 9.2002H28.5V10.0002H29.3V9.2002Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 9.2002H29.2996V10.0002H29.6996C29.8057 10.0002 29.9074 9.95805 29.9825 9.88304C30.0575 9.80802 30.0996 9.70628 30.0996 9.6002",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 9.2002H30.9004V10.0002H31.7004V9.2002Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 10H33.3V9.2H32.9C32.7939 9.2 32.6922 9.24214 32.6172 9.31716C32.5421 9.39217 32.5 9.49391 32.5 9.6",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 9.2002H33.2998V10.0002H34.0998V9.2002Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 9.2002H34.0996V10.0002H34.8996V9.2002Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 9.2002H34.9004V10.0002H35.7004V9.2002Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 10H38.0998V9.6C38.0998 9.49391 38.0577 9.39217 37.9826 9.31716C37.9076 9.24214 37.8059 9.2 37.6998 9.2C37.5937 9.2 37.492 9.24214 37.417 9.31716C37.3419 9.39217 37.2998 9.49391 37.2998 9.6",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 10.7998H6.89961V9.9998H6.49961C6.39352 9.9998 6.29178 10.0419 6.21677 10.117C6.14175 10.192 6.09961 10.2937 6.09961 10.3998",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 10V10.8H7.30039C7.40648 10.8 7.50822 10.7579 7.58323 10.6828C7.65825 10.6078 7.70039 10.5061 7.70039 10.4C7.70039 10.2939 7.65825 10.1922 7.58323 10.1172C7.50822 10.0421 7.40648 10 7.30039 10",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.7998H9.3V9.9998H8.9C8.79391 9.9998 8.69217 10.0419 8.61716 10.117C8.54214 10.192 8.5 10.2937 8.5 10.3998",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 10H9.2998V10.8H10.0998V10Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 10H10.0996V10.8H10.8996V10Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.7998V9.9998H11.7V10.3998C11.7 10.5059 11.7421 10.6076 11.8172 10.6826C11.8922 10.7577 11.9939 10.7998 12.1 10.7998",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 10H12.5V10.8H13.3V10Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 10H13.2998V10.8H14.0998V10Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 10H14.1004V10.8H14.5004C14.6065 10.8 14.7082 10.7579 14.7832 10.6828C14.8582 10.6078 14.9004 10.5061 14.9004 10.4",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.7998V9.9998H16.1C15.9939 9.9998 15.8922 10.0419 15.8172 10.117C15.7421 10.192 15.7 10.2937 15.7 10.3998C15.7 10.5059 15.7421 10.6076 15.8172 10.6826C15.8922 10.7577 15.9939 10.7998 16.1 10.7998",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10V10.8H16.9C17.0061 10.8 17.1078 10.7579 17.1828 10.6828C17.2579 10.6078 17.3 10.5061 17.3 10.4C17.3 10.2939 17.2579 10.1922 17.1828 10.1172C17.1078 10.0421 17.0061 10 16.9 10",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 10.7998H20.5002V9.9998H20.1002C19.9941 9.9998 19.8924 10.0419 19.8174 10.117C19.7423 10.192 19.7002 10.2937 19.7002 10.3998",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10V10.8H20.9C21.0061 10.8 21.1078 10.7579 21.1828 10.6828C21.2579 10.6078 21.3 10.5061 21.3 10.4C21.3 10.2939 21.2579 10.1922 21.1828 10.1172C21.1078 10.0421 21.0061 10 20.9 10",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 10.7998V9.9998H22.1004V10.3998C22.1004 10.5059 22.1425 10.6076 22.2175 10.6826C22.2926 10.7577 22.3943 10.7998 22.5004 10.7998",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 10H22.9002V10.8H23.3002C23.4063 10.8 23.508 10.7579 23.583 10.6828C23.6581 10.6078 23.7002 10.5061 23.7002 10.4",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10.7998H25.3V9.9998H24.9C24.7939 9.9998 24.6922 10.0419 24.6172 10.117C24.5421 10.192 24.5 10.2937 24.5 10.3998",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 10V10.8H25.6998C25.8059 10.8 25.9076 10.7579 25.9826 10.6828C26.0577 10.6078 26.0998 10.5061 26.0998 10.4C26.0998 10.2939 26.0577 10.1922 25.9826 10.1172C25.9076 10.0421 25.8059 10 25.6998 10",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 10.7998V9.9998H27.7V10.3998C27.7 10.5059 27.7421 10.6076 27.8172 10.6826C27.8922 10.7577 27.9939 10.7998 28.1 10.7998",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 10H28.4998V10.8H28.8998C29.0059 10.8 29.1076 10.7579 29.1826 10.6828C29.2577 10.6078 29.2998 10.5061 29.2998 10.4",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 10H30.9004V10.8H31.7004V10Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 10H31.7002V10.8H32.5002V10Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 10H32.5V10.8H33.3V10Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0996 10H33.2996V10.8H33.6996C33.8057 10.8 33.9074 10.7579 33.9825 10.6828C34.0575 10.6078 34.0996 10.5061 34.0996 10.4",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 10H34.9002V10.4C34.9002 10.5061 34.9423 10.6078 35.0174 10.6828C35.0924 10.7579 35.1941 10.8 35.3002 10.8C35.4063 10.8 35.508 10.7579 35.583 10.6828C35.6581 10.6078 35.7002 10.5061 35.7002 10.4",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0996 10H37.2996V10.4C37.2996 10.5061 37.3418 10.6078 37.4168 10.6828C37.4918 10.7579 37.5935 10.8 37.6996 10.8C37.8057 10.8 37.9074 10.7579 37.9825 10.6828C38.0575 10.6078 38.0996 10.5061 38.0996 10.4",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 11.6001H3.70039V11.2001C3.70039 11.094 3.65825 10.9923 3.58323 10.9173C3.50822 10.8422 3.40648 10.8001 3.30039 10.8001C3.1943 10.8001 3.09256 10.8422 3.01755 10.9173C2.94253 10.9923 2.90039 11.094 2.90039 11.2001",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 11.6001V10.8001H5.69961C5.59352 10.8001 5.49178 10.8422 5.41677 10.9173C5.34175 10.9923 5.29961 11.094 5.29961 11.2001C5.29961 11.3062 5.34175 11.4079 5.41677 11.4829C5.49178 11.558 5.59352 11.6001 5.69961 11.6001",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 10.7998H6.09961V11.5998H6.89961V10.7998Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 11.6001H8.5002V10.8001H8.1002C7.99411 10.8001 7.89237 10.8422 7.81735 10.9173C7.74234 10.9923 7.7002 11.094 7.7002 11.2001",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 10.7998H8.5V11.5998H9.3V10.7998Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 10.7998H9.2998V11.5998H10.0998V10.7998Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 10.7998H10.0996V11.5998H10.8996V10.7998Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 10.7998V11.5998H11.3004C11.4065 11.5998 11.5082 11.5577 11.5832 11.4826C11.6582 11.4076 11.7004 11.3059 11.7004 11.1998C11.7004 11.0937 11.6582 10.992 11.5832 10.917C11.5082 10.8419 11.4065 10.7998 11.3004 10.7998",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 10.7998H12.5V11.5998H13.3V10.7998Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 11.6001V10.8001H19.3002C19.1941 10.8001 19.0924 10.8422 19.0174 10.9173C18.9423 10.9923 18.9002 11.094 18.9002 11.2001C18.9002 11.3062 18.9423 11.4079 19.0174 11.4829C19.0924 11.558 19.1941 11.6001 19.3002 11.6001",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 10.7998H19.7002V11.5998H20.5002V10.7998Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 10.7998H24.5V11.5998H25.3V10.7998Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 11.6001V10.8001H29.6996C29.5935 10.8001 29.4918 10.8422 29.4168 10.9173C29.3418 10.9923 29.2996 11.094 29.2996 11.2001C29.2996 11.3062 29.3418 11.4079 29.4168 11.4829C29.4918 11.558 29.5935 11.6001 29.6996 11.6001",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 10.7998H30.0996V11.5998H30.8996V10.7998Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 10.7998H30.9002V11.5998H31.3002C31.4063 11.5998 31.508 11.5577 31.583 11.4826C31.6581 11.4076 31.7002 11.3059 31.7002 11.1998",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4996 11.5998C34.7205 11.5998 34.8996 11.4207 34.8996 11.1998C34.8996 10.9789 34.7205 10.7998 34.4996 10.7998C34.2787 10.7998 34.0996 10.9789 34.0996 11.1998C34.0996 11.4207 34.2787 11.5998 34.4996 11.5998Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 11.5998C37.1209 11.5998 37.3 11.4207 37.3 11.1998C37.3 10.9789 37.1209 10.7998 36.9 10.7998C36.6791 10.7998 36.5 10.9789 36.5 11.1998C36.5 11.4207 36.6791 11.5998 36.9 11.5998Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70039 11.6001H2.90039V12.4001H3.70039V11.6001Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.3999H5.3V11.9999C5.3 11.8938 5.25786 11.7921 5.18284 11.7171C5.10783 11.642 5.00609 11.5999 4.9 11.5999C4.79391 11.5999 4.69217 11.642 4.61716 11.7171C4.54214 11.7921 4.5 11.8938 4.5 11.9999",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 12.3999V11.5999H6.10039V11.9999C6.10039 12.106 6.14253 12.2077 6.21755 12.2827C6.29256 12.3578 6.3943 12.3999 6.50039 12.3999",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70039 11.6001H6.90039V12.4001H7.70039V11.6001Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 11.6001H7.7002V12.4001H8.5002V11.6001Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 11.6001H9.2998V12.4001H10.0998V11.6001Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 11.6001H10.0996V12.4001H10.8996V11.6001Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 11.6001H12.5V12.4001H13.3V11.6001Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 11.6001V12.4001H14.0998V12.0001C14.0998 11.894 14.0577 11.7923 13.9826 11.7173C13.9076 11.6422 13.8059 11.6001 13.6998 11.6001",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 12.3999H18.0998V11.5999H17.6998C17.5937 11.5999 17.492 11.642 17.417 11.7171C17.3419 11.7921 17.2998 11.8938 17.2998 11.9999",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0996 11.6001V12.4001H18.8996V12.0001C18.8996 11.894 18.8575 11.7923 18.7825 11.7173C18.7074 11.6422 18.6057 11.6001 18.4996 11.6001",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.6001H19.7V12.0001C19.7 12.1062 19.7421 12.2079 19.8172 12.2829C19.8922 12.358 19.9939 12.4001 20.1 12.4001C20.2061 12.4001 20.3078 12.358 20.3828 12.2829C20.4579 12.2079 20.5 12.1062 20.5 12.0001",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 12.3999V11.5999H22.5004C22.3943 11.5999 22.2926 11.642 22.2175 11.7171C22.1425 11.7921 22.1004 11.8938 22.1004 11.9999C22.1004 12.106 22.1425 12.2077 22.2175 12.2827C22.2926 12.3578 22.3943 12.3999 22.5004 12.3999",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7004 11.6001H22.9004V12.4001H23.7004V11.6001Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 11.6001H23.7002V12.4001H24.5002V11.6001Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 11.6001H24.5V12.4001H25.3V11.6001Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 11.6001V12.4001H26.0998V12.0001C26.0998 11.894 26.0577 11.7923 25.9826 11.7173C25.9076 11.6422 25.8059 11.6001 25.6998 11.6001",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 12.3999V11.5999H28.1C27.9939 11.5999 27.8922 11.642 27.8172 11.7171C27.7421 11.7921 27.7 11.8938 27.7 11.9999C27.7 12.106 27.7421 12.2077 27.8172 12.2827C27.8922 12.3578 27.9939 12.3999 28.1 12.3999",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.6001V12.4001H28.9C29.0061 12.4001 29.1078 12.358 29.1828 12.2829C29.2579 12.2079 29.3 12.1062 29.3 12.0001C29.3 11.894 29.2579 11.7923 29.1828 11.7173C29.1078 11.6422 29.0061 11.6001 28.9 11.6001",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 12.3999H32.5002V11.9999C32.5002 11.8938 32.4581 11.7921 32.383 11.7171C32.308 11.642 32.2063 11.5999 32.1002 11.5999C31.9941 11.5999 31.8924 11.642 31.8174 11.7171C31.7423 11.7921 31.7002 11.8938 31.7002 11.9999",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 12.3999V11.5999H35.3002C35.1941 11.5999 35.0924 11.642 35.0174 11.7171C34.9423 11.7921 34.9002 11.8938 34.9002 11.9999C34.9002 12.106 34.9423 12.2077 35.0174 12.2827C35.0924 12.3578 35.1941 12.3999 35.3002 12.3999",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 11.6001V12.4001H36.1002C36.2063 12.4001 36.308 12.358 36.383 12.2829C36.4581 12.2079 36.5002 12.1062 36.5002 12.0001C36.5002 11.894 36.4581 11.7923 36.383 11.7173C36.308 11.6422 36.2063 11.6001 36.1002 11.6001",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09961 13.2002H2.89961V12.4002H2.49961C2.39352 12.4002 2.29178 12.4423 2.21677 12.5174C2.14175 12.5924 2.09961 12.6941 2.09961 12.8002",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70039 12.3999H2.90039V13.1999H3.70039V12.3999Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5002 12.3999H3.7002V13.1999H4.5002V12.3999Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 12.3999H4.5V13.1999H5.3V12.3999Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 12.3999V13.1999H5.6998C5.80589 13.1999 5.90763 13.1578 5.98265 13.0827C6.05766 13.0077 6.0998 12.906 6.0998 12.7999C6.0998 12.6938 6.05766 12.5921 5.98265 12.5171C5.90763 12.442 5.80589 12.3999 5.6998 12.3999",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 12.3999H7.7002V13.1999H8.5002V12.3999Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 12.3999H8.5V13.1999H9.3V12.3999Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 12.3999H9.2998V13.1999H10.0998V12.3999Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 12.3999H10.0996V13.1999H10.8996V12.3999Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 12.3999V13.1999H11.7004V12.7999C11.7004 12.6938 11.6582 12.5921 11.5832 12.5171C11.5082 12.442 11.4065 12.3999 11.3004 12.3999",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 12.3999H12.5V13.1999H13.3V12.3999Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 12.3999H13.2998V13.1999H14.0998V12.3999Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 12.3999V13.1999H14.4996C14.6057 13.1999 14.7074 13.1578 14.7825 13.0827C14.8575 13.0077 14.8996 12.906 14.8996 12.7999C14.8996 12.6938 14.8575 12.5921 14.7825 12.5171C14.7074 12.442 14.6057 12.3999 14.4996 12.3999",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0996 13.2002V12.4002H17.2996V12.8002C17.2996 12.9063 17.3418 13.008 17.4168 13.083C17.4918 13.1581 17.5935 13.2002 17.6996 13.2002",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 12.3999H18.1004V13.1999H18.5004C18.6065 13.1999 18.7082 13.1578 18.7832 13.0827C18.8582 13.0077 18.9004 12.906 18.9004 12.7999",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 12.3999H22.9002V12.7999C22.9002 12.906 22.9423 13.0077 23.0174 13.0827C23.0924 13.1578 23.1941 13.1999 23.3002 13.1999C23.4063 13.1999 23.508 13.1578 23.583 13.0827C23.6581 13.0077 23.7002 12.906 23.7002 12.7999",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 12.3999H25.2996V12.7999C25.2996 12.906 25.3418 13.0077 25.4168 13.0827C25.4918 13.1578 25.5935 13.1999 25.6996 13.1999C25.8057 13.1999 25.9074 13.1578 25.9825 13.0827C26.0575 13.0077 26.0996 12.906 26.0996 12.7999",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 13.2002V12.4002H31.3002C31.1941 12.4002 31.0924 12.4423 31.0174 12.5174C30.9423 12.5924 30.9002 12.6941 30.9002 12.8002C30.9002 12.9063 30.9423 13.008 31.0174 13.083C31.0924 13.1581 31.1941 13.2002 31.3002 13.2002",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 12.3999H31.7002V13.1999H32.5002V12.3999Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 12.3999V13.1999H33.3V12.7999C33.3 12.6938 33.2579 12.5921 33.1828 12.5171C33.1078 12.442 33.0061 12.3999 32.9 12.3999",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4996 13.1999C34.7205 13.1999 34.8996 13.0208 34.8996 12.7999C34.8996 12.579 34.7205 12.3999 34.4996 12.3999C34.2787 12.3999 34.0996 12.579 34.0996 12.7999C34.0996 13.0208 34.2787 13.1999 34.4996 13.1999Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 14V13.2H2.10039V13.6C2.10039 13.7061 2.14253 13.8078 2.21755 13.8828C2.29256 13.9579 2.3943 14 2.50039 14",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7002 13.2002H2.9002V14.0002H3.3002C3.40628 14.0002 3.50802 13.9581 3.58304 13.883C3.65805 13.808 3.7002 13.7063 3.7002 13.6002",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 13.2002H4.4998V13.6002C4.4998 13.7063 4.54195 13.808 4.61696 13.883C4.69198 13.9581 4.79372 14.0002 4.8998 14.0002C5.00589 14.0002 5.10763 13.9581 5.18265 13.883C5.25766 13.808 5.2998 13.7063 5.2998 13.6002",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 14V13.2H6.50039C6.3943 13.2 6.29256 13.2421 6.21755 13.3172C6.14253 13.3922 6.10039 13.4939 6.10039 13.6C6.10039 13.7061 6.14253 13.8078 6.21755 13.8828C6.29256 13.9579 6.3943 14 6.50039 14",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70039 13.2002H6.90039V14.0002H7.70039V13.2002Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.2002H7.7V14.0002H8.1C8.20609 14.0002 8.30783 13.9581 8.38284 13.883C8.45786 13.808 8.5 13.7063 8.5 13.6002",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 14V13.2H10.9002V13.6C10.9002 13.7061 10.9423 13.8078 11.0174 13.8828C11.0924 13.9579 11.1941 14 11.3002 14",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 13.2002H11.7002V14.0002H12.5002V13.2002Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 13.2002H12.5V14.0002H13.3V13.2002Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 14H16.5002V13.2H16.1002C15.9941 13.2 15.8924 13.2421 15.8174 13.3172C15.7423 13.3922 15.7002 13.4939 15.7002 13.6",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.2002V14.0002H17.3V13.6002C17.3 13.4941 17.2579 13.3924 17.1828 13.3174C17.1078 13.2423 17.0061 13.2002 16.9 13.2002",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 14V13.2H19.3002C19.1941 13.2 19.0924 13.2421 19.0174 13.3172C18.9423 13.3922 18.9002 13.4939 18.9002 13.6C18.9002 13.7061 18.9423 13.8078 19.0174 13.8828C19.0924 13.9579 19.1941 14 19.3002 14",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 13.2002V14.0002H20.1002C20.2063 14.0002 20.308 13.9581 20.383 13.883C20.4581 13.808 20.5002 13.7063 20.5002 13.6002C20.5002 13.4941 20.4581 13.3924 20.383 13.3174C20.308 13.2423 20.2063 13.2002 20.1002 13.2002",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4996 14.0002C22.7205 14.0002 22.8996 13.8211 22.8996 13.6002C22.8996 13.3793 22.7205 13.2002 22.4996 13.2002C22.2787 13.2002 22.0996 13.3793 22.0996 13.6002C22.0996 13.8211 22.2787 14.0002 22.4996 14.0002Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 14H24.5002V13.6C24.5002 13.4939 24.4581 13.3922 24.383 13.3172C24.308 13.2421 24.2063 13.2 24.1002 13.2C23.9941 13.2 23.8924 13.2421 23.8174 13.3172C23.7423 13.3922 23.7002 13.4939 23.7002 13.6",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 14H26.8996V13.2H26.4996C26.3935 13.2 26.2918 13.2421 26.2168 13.3172C26.1418 13.3922 26.0996 13.4939 26.0996 13.6",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 13.2002V14.0002H27.7004V13.6002C27.7004 13.4941 27.6582 13.3924 27.5832 13.3174C27.5082 13.2423 27.4065 13.2002 27.3004 13.2002",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2998 13.2002H32.4998V13.6002C32.4998 13.7063 32.5419 13.808 32.617 13.883C32.692 13.9581 32.7937 14.0002 32.8998 14.0002C33.0059 14.0002 33.1076 13.9581 33.1826 13.883C33.2577 13.808 33.2998 13.7063 33.2998 13.6002",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3004 14.0002C35.5213 14.0002 35.7004 13.8211 35.7004 13.6002C35.7004 13.3793 35.5213 13.2002 35.3004 13.2002C35.0795 13.2002 34.9004 13.3793 34.9004 13.6002C34.9004 13.8211 35.0795 14.0002 35.3004 14.0002Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 14.0002C37.1209 14.0002 37.3 13.8211 37.3 13.6002C37.3 13.3793 37.1209 13.2002 36.9 13.2002C36.6791 13.2002 36.5 13.3793 36.5 13.6002C36.5 13.8211 36.6791 14.0002 36.9 14.0002Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.7998H9.3V13.9998H8.9C8.79391 13.9998 8.69217 14.0419 8.61716 14.117C8.54214 14.192 8.5 14.2937 8.5 14.3998",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 14V14.8H10.0998V14.4C10.0998 14.2939 10.0577 14.1922 9.98265 14.1172C9.90763 14.0421 9.80589 14 9.6998 14",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 14H12.5V14.8H13.3V14Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 14.7998H15.7004V13.9998H15.3004C15.1943 13.9998 15.0926 14.0419 15.0175 14.117C14.9425 14.192 14.9004 14.2937 14.9004 14.3998",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 14H15.7002V14.8H16.5002V14Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 14H16.4998V14.8H16.8998C17.0059 14.8 17.1076 14.7579 17.1826 14.6828C17.2577 14.6078 17.2998 14.5061 17.2998 14.4",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4996 14.8C18.7205 14.8 18.8996 14.6209 18.8996 14.4C18.8996 14.1791 18.7205 14 18.4996 14C18.2787 14 18.0996 14.1791 18.0996 14.4C18.0996 14.6209 18.2787 14.8 18.4996 14.8Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 14.7998V13.9998H20.8998C20.7937 13.9998 20.692 14.0419 20.617 14.117C20.5419 14.192 20.4998 14.2937 20.4998 14.3998C20.4998 14.5059 20.5419 14.6076 20.617 14.6826C20.692 14.7577 20.7937 14.7998 20.8998 14.7998",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 14V14.8H22.0998V14.4C22.0998 14.2939 22.0577 14.1922 21.9826 14.1172C21.9076 14.0421 21.8059 14 21.6998 14",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 14.7998H23.7004V13.9998H23.3004C23.1943 13.9998 23.0926 14.0419 23.0175 14.117C22.9425 14.192 22.9004 14.2937 22.9004 14.3998",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 14H23.7002V14.8H24.5002V14Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 14H26.0996V14.8H26.8996V14Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 14H26.9002V14.8H27.3002C27.4063 14.8 27.508 14.7579 27.583 14.6828C27.6581 14.6078 27.7002 14.5061 27.7002 14.4",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 14.7998V13.9998H31.3002C31.1941 13.9998 31.0924 14.0419 31.0174 14.117C30.9423 14.192 30.9002 14.2937 30.9002 14.3998C30.9002 14.5059 30.9423 14.6076 31.0174 14.6826C31.0924 14.7577 31.1941 14.7998 31.3002 14.7998",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 14V14.8H32.1002C32.2063 14.8 32.308 14.7579 32.383 14.6828C32.4581 14.6078 32.5002 14.5061 32.5002 14.4C32.5002 14.2939 32.4581 14.1922 32.383 14.1172C32.308 14.0421 32.2063 14 32.1002 14",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1002 14.8C36.3211 14.8 36.5002 14.6209 36.5002 14.4C36.5002 14.1791 36.3211 14 36.1002 14C35.8793 14 35.7002 14.1791 35.7002 14.4C35.7002 14.6209 35.8793 14.8 36.1002 14.8Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09961 15.6001H2.89961V15.2001C2.89961 15.094 2.85747 14.9923 2.78245 14.9173C2.70744 14.8422 2.6057 14.8001 2.49961 14.8001C2.39352 14.8001 2.29178 14.8422 2.21677 14.9173C2.14175 14.9923 2.09961 15.094 2.09961 15.2001",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.6001V14.8001H4.1C3.99391 14.8001 3.89217 14.8422 3.81716 14.9173C3.74214 14.9923 3.7 15.094 3.7 15.2001C3.7 15.3062 3.74214 15.4079 3.81716 15.4829C3.89217 15.558 3.99391 15.6001 4.1 15.6001",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.7998V15.5998H4.9C5.00609 15.5998 5.10783 15.5577 5.18284 15.4826C5.25786 15.4076 5.3 15.3059 5.3 15.1998C5.3 15.0937 5.25786 14.992 5.18284 14.917C5.10783 14.8419 5.00609 14.7998 4.9 14.7998",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 15.6001V14.8001H7.3002C7.19411 14.8001 7.09237 14.8422 7.01735 14.9173C6.94234 14.9923 6.9002 15.094 6.9002 15.2001C6.9002 15.3062 6.94234 15.4079 7.01735 15.4829C7.09237 15.558 7.19411 15.6001 7.3002 15.6001",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 14.7998H7.7002V15.5998H8.5002V14.7998Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 14.7998H8.5V15.5998H9.3V14.7998Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 14.7998H9.2998V15.5998H10.0998V14.7998Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.6001V14.8001H12.1C11.9939 14.8001 11.8922 14.8422 11.8172 14.9173C11.7421 14.9923 11.7 15.094 11.7 15.2001C11.7 15.3062 11.7421 15.4079 11.8172 15.4829C11.8922 15.558 11.9939 15.6001 12.1 15.6001",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 14.7998H12.4998V15.5998H12.8998C13.0059 15.5998 13.1076 15.5577 13.1826 15.4826C13.2577 15.4076 13.2998 15.3059 13.2998 15.1998",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 14.7998H14.9004V15.5998H15.7004V14.7998Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.7998H15.7V15.5998H16.1C16.2061 15.5998 16.3078 15.5577 16.3828 15.4826C16.4579 15.4076 16.5 15.3059 16.5 15.1998",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 15.6001H19.7004V15.2001C19.7004 15.094 19.6582 14.9923 19.5832 14.9173C19.5082 14.8422 19.4065 14.8001 19.3004 14.8001C19.1943 14.8001 19.0926 14.8422 19.0175 14.9173C18.9425 14.9923 18.9004 15.094 18.9004 15.2001",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 14.7998H21.2996V15.1998C21.2996 15.3059 21.3418 15.4076 21.4168 15.4826C21.4918 15.5577 21.5935 15.5998 21.6996 15.5998C21.8057 15.5998 21.9074 15.5577 21.9825 15.4826C22.0575 15.4076 22.0996 15.3059 22.0996 15.1998",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 15.6001V14.8001H22.9002V15.2001C22.9002 15.3062 22.9423 15.4079 23.0174 15.4829C23.0924 15.558 23.1941 15.6001 23.3002 15.6001",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 14.7998H23.7002V15.5998H24.5002V14.7998Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.7998V15.5998H25.3V15.1998C25.3 15.0937 25.2579 14.992 25.1828 14.917C25.1078 14.8419 25.0061 14.7998 24.9 14.7998",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 14.7998H26.0996V15.5998H26.8996V14.7998Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 15.6001H28.5002V14.8001H28.1002C27.9941 14.8001 27.8924 14.8422 27.8174 14.9173C27.7423 14.9923 27.7002 15.094 27.7002 15.2001",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 14.7998H28.5V15.5998H29.3V14.7998Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 14.7998H29.2998V15.5998H30.0998V14.7998Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 14.7998V15.5998H30.8996V15.1998C30.8996 15.0937 30.8575 14.992 30.7825 14.917C30.7074 14.8419 30.6057 14.7998 30.4996 14.7998",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2998 15.6001V14.8001H32.8998C32.7937 14.8001 32.692 14.8422 32.617 14.9173C32.5419 14.9923 32.4998 15.094 32.4998 15.2001C32.4998 15.3062 32.5419 15.4079 32.617 15.4829C32.692 15.558 32.7937 15.6001 32.8998 15.6001",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2998 14.7998V15.5998H33.6998C33.8059 15.5998 33.9076 15.5577 33.9826 15.4826C34.0577 15.4076 34.0998 15.3059 34.0998 15.1998C34.0998 15.0937 34.0577 14.992 33.9826 14.917C33.9076 14.8419 33.8059 14.7998 33.6998 14.7998",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3004 15.5998C35.5213 15.5998 35.7004 15.4207 35.7004 15.1998C35.7004 14.9789 35.5213 14.7998 35.3004 14.7998C35.0795 14.7998 34.9004 14.9789 34.9004 15.1998C34.9004 15.4207 35.0795 15.5998 35.3004 15.5998Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 15.6001H37.3V15.2001C37.3 15.094 37.2579 14.9923 37.1828 14.9173C37.1078 14.8422 37.0061 14.8001 36.9 14.8001C36.7939 14.8001 36.6922 14.8422 36.6172 14.9173C36.5421 14.9923 36.5 15.094 36.5 15.2001",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 15.6001H2.10039V16.0001C2.10039 16.1062 2.14253 16.2079 2.21755 16.2829C2.29256 16.358 2.3943 16.4001 2.50039 16.4001C2.60648 16.4001 2.70822 16.358 2.78323 16.2829C2.85825 16.2079 2.90039 16.1062 2.90039 16.0001",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 16.3999H6.89961V15.9999C6.89961 15.8938 6.85747 15.7921 6.78245 15.7171C6.70744 15.642 6.6057 15.5999 6.49961 15.5999C6.39352 15.5999 6.29178 15.642 6.21677 15.7171C6.14175 15.7921 6.09961 15.8938 6.09961 15.9999",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.3999V15.5999H7.7V15.9999C7.7 16.106 7.74214 16.2077 7.81716 16.2827C7.89217 16.3578 7.99391 16.3999 8.1 16.3999",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 15.6001H8.5V16.4001H9.3V15.6001Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 15.6001H9.2998V16.4001H10.0998V15.6001Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 15.6001V16.4001H10.8996V16.0001C10.8996 15.894 10.8575 15.7923 10.7825 15.7173C10.7074 15.6422 10.6057 15.6001 10.4996 15.6001",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 15.6001H14.9004V16.4001H15.7004V15.6001Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 16.3999V15.5999H16.8998C16.7937 15.5999 16.692 15.642 16.617 15.7171C16.5419 15.7921 16.4998 15.8938 16.4998 15.9999C16.4998 16.106 16.5419 16.2077 16.617 16.2827C16.692 16.3578 16.7937 16.3999 16.8998 16.3999",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0998 15.6001H17.2998V16.4001H18.0998V15.6001Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 15.6001H18.0996V16.4001H18.8996V15.6001Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 15.6001H18.9002V16.4001H19.3002C19.4063 16.4001 19.508 16.358 19.583 16.2829C19.6581 16.2079 19.7002 16.1062 19.7002 16.0001",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 16.4001C21.1209 16.4001 21.3 16.221 21.3 16.0001C21.3 15.7792 21.1209 15.6001 20.9 15.6001C20.6791 15.6001 20.5 15.7792 20.5 16.0001C20.5 16.221 20.6791 16.4001 20.9 16.4001Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4996 16.4001C22.7205 16.4001 22.8996 16.221 22.8996 16.0001C22.8996 15.7792 22.7205 15.6001 22.4996 15.6001C22.2787 15.6001 22.0996 15.7792 22.0996 16.0001C22.0996 16.221 22.2787 16.4001 22.4996 16.4001Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 15.6001H23.7002V16.4001H24.5002V15.6001Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 15.6001H24.5V16.4001H25.3V15.6001Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 15.6001H25.2998V16.4001H26.0998V15.6001Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 15.6001H26.0996V16.4001H26.8996V15.6001Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 15.6001H27.7002V16.4001H28.5002V15.6001Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 16.3999V15.5999H29.2996V15.9999C29.2996 16.106 29.3418 16.2077 29.4168 16.2827C29.4918 16.3578 29.5935 16.3999 29.6996 16.3999",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 15.6001H30.0996V16.4001H30.8996V15.6001Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 15.6001V16.4001H31.7004V16.0001C31.7004 15.894 31.6582 15.7923 31.5832 15.7173C31.5082 15.6422 31.4065 15.6001 31.3004 15.6001",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4996 16.4001C34.7205 16.4001 34.8996 16.221 34.8996 16.0001C34.8996 15.7792 34.7205 15.6001 34.4996 15.6001C34.2787 15.6001 34.0996 15.7792 34.0996 16.0001C34.0996 16.221 34.2787 16.4001 34.4996 16.4001Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 16.3999H36.5002V15.5999H36.1002C35.9941 15.5999 35.8924 15.642 35.8174 15.7171C35.7423 15.7921 35.7002 15.8938 35.7002 15.9999",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 15.6001H36.5V16.4001H37.3V15.6001Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 15.6001V16.4001H38.0998V16.0001C38.0998 15.894 38.0577 15.7923 37.9826 15.7173C37.9076 15.6422 37.8059 15.6001 37.6998 15.6001",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 17.1999C5.12091 17.1999 5.3 17.0208 5.3 16.7999C5.3 16.579 5.12091 16.3999 4.9 16.3999C4.67909 16.3999 4.5 16.579 4.5 16.7999C4.5 17.0208 4.67909 17.1999 4.9 17.1999Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 17.2002V16.4002H6.10039V16.8002C6.10039 16.9063 6.14253 17.008 6.21755 17.083C6.29256 17.1581 6.3943 17.2002 6.50039 17.2002",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 16.3999V17.1999H7.30039C7.40648 17.1999 7.50822 17.1578 7.58323 17.0827C7.65825 17.0077 7.70039 16.906 7.70039 16.7999C7.70039 16.6938 7.65825 16.5921 7.58323 16.5171C7.50822 16.442 7.40648 16.3999 7.30039 16.3999",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 16.3999H8.4998V16.7999C8.4998 16.906 8.54195 17.0077 8.61696 17.0827C8.69198 17.1578 8.79372 17.1999 8.8998 17.1999C9.00589 17.1999 9.10763 17.1578 9.18265 17.0827C9.25766 17.0077 9.2998 16.906 9.2998 16.7999",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 16.3999H10.0996V17.1999H10.8996V16.3999Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.2002H13.3V16.8002C13.3 16.6941 13.2579 16.5924 13.1828 16.5174C13.1078 16.4423 13.0061 16.4002 12.9 16.4002C12.7939 16.4002 12.6922 16.4423 12.6172 16.5174C12.5421 16.5924 12.5 16.6941 12.5 16.8002",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 16.3999H14.9004V17.1999H15.7004V16.3999Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 16.3999V17.1999H16.1002C16.2063 17.1999 16.308 17.1578 16.383 17.0827C16.4581 17.0077 16.5002 16.906 16.5002 16.7999C16.5002 16.6938 16.4581 16.5921 16.383 16.5171C16.308 16.442 16.2063 16.3999 16.1002 16.3999",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 17.2002V16.4002H23.7V16.8002C23.7 16.9063 23.7421 17.008 23.8172 17.083C23.8922 17.1581 23.9939 17.2002 24.1 17.2002",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 16.3999H24.4998V17.1999H24.8998C25.0059 17.1999 25.1076 17.1578 25.1826 17.0827C25.2577 17.0077 25.2998 16.906 25.2998 16.7999",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 17.2002V16.4002H26.1004V16.8002C26.1004 16.9063 26.1425 17.008 26.2175 17.083C26.2926 17.1581 26.3943 17.2002 26.5004 17.2002",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 16.3999H26.9004V17.1999H27.7004V16.3999Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 16.3999H27.7002V17.1999H28.5002V16.3999Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16.3999V17.1999H29.3V16.7999C29.3 16.6938 29.2579 16.5921 29.1828 16.5171C29.1078 16.442 29.0061 16.3999 28.9 16.3999",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 16.3999H30.9004V17.1999H31.7004V16.3999Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 16.3999V17.1999H32.5002V16.7999C32.5002 16.6938 32.4581 16.5921 32.383 16.5171C32.308 16.442 32.2063 16.3999 32.1002 16.3999",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 17.2002V16.4002H35.3002C35.1941 16.4002 35.0924 16.4423 35.0174 16.5174C34.9423 16.5924 34.9002 16.6941 34.9002 16.8002C34.9002 16.9063 34.9423 17.008 35.0174 17.083C35.0924 17.1581 35.1941 17.2002 35.3002 17.2002",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5002 16.3999H35.7002V17.1999H36.5002V16.3999Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 16.3999H36.5V17.1999H37.3V16.3999Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0996 16.3999H37.2996V17.1999H37.6996C37.8057 17.1999 37.9074 17.1578 37.9825 17.0827C38.0575 17.0077 38.0996 16.906 38.0996 16.7999",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09961 18H2.89961V17.2H2.49961C2.39352 17.2 2.29178 17.2421 2.21677 17.3172C2.14175 17.3922 2.09961 17.4939 2.09961 17.6",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 17.2002V18.0002H3.30039C3.40648 18.0002 3.50822 17.9581 3.58323 17.883C3.65825 17.808 3.70039 17.7063 3.70039 17.6002C3.70039 17.4941 3.65825 17.3924 3.58323 17.3174C3.50822 17.2423 3.40648 17.2002 3.30039 17.2002",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 18H6.0998V17.6C6.0998 17.4939 6.05766 17.3922 5.98265 17.3172C5.90763 17.2421 5.80589 17.2 5.6998 17.2C5.59372 17.2 5.49198 17.2421 5.41696 17.3172C5.34195 17.3922 5.2998 17.4939 5.2998 17.6",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 18H8.5002V17.6C8.5002 17.4939 8.45805 17.3922 8.38304 17.3172C8.30802 17.2421 8.20628 17.2 8.1002 17.2C7.99411 17.2 7.89237 17.2421 7.81735 17.3172C7.74234 17.3922 7.7002 17.4939 7.7002 17.6",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 17.2002H10.1004V17.6002C10.1004 17.7063 10.1425 17.808 10.2175 17.883C10.2926 17.9581 10.3943 18.0002 10.5004 18.0002C10.6065 18.0002 10.7082 17.9581 10.7832 17.883C10.8582 17.808 10.9004 17.7063 10.9004 17.6002",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18V17.2H12.1C11.9939 17.2 11.8922 17.2421 11.8172 17.3172C11.7421 17.3922 11.7 17.4939 11.7 17.6C11.7 17.7061 11.7421 17.8078 11.8172 17.8828C11.8922 17.9579 11.9939 18 12.1 18",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 17.2002H12.5V18.0002H13.3V17.2002Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 17.2002H13.2998V18.0002H14.0998V17.2002Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8996 17.2002H14.0996V18.0002H14.8996V17.2002Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 17.2002H14.9004V18.0002H15.7004V17.2002Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6998 18.0002C25.9207 18.0002 26.0998 17.8211 26.0998 17.6002C26.0998 17.3793 25.9207 17.2002 25.6998 17.2002C25.4789 17.2002 25.2998 17.3793 25.2998 17.6002C25.2998 17.8211 25.4789 18.0002 25.6998 18.0002Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 17.2002H28.5V18.0002H29.3V17.2002Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 17.2002V18.0002H29.6998C29.8059 18.0002 29.9076 17.9581 29.9826 17.883C30.0577 17.808 30.0998 17.7063 30.0998 17.6002C30.0998 17.4941 30.0577 17.3924 29.9826 17.3174C29.9076 17.2423 29.8059 17.2002 29.6998 17.2002",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 17.2002H30.9004V18.0002H31.7004V17.2002Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 17.2002H31.7002V18.0002H32.5002V17.2002Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17.2002V18.0002H33.3V17.6002C33.3 17.4941 33.2579 17.3924 33.1828 17.3174C33.1078 17.2423 33.0061 17.2002 32.9 17.2002",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0996 18H34.8996V17.6C34.8996 17.4939 34.8575 17.3922 34.7825 17.3172C34.7074 17.2421 34.6057 17.2 34.4996 17.2C34.3935 17.2 34.2918 17.2421 34.2168 17.3172C34.1418 17.3922 34.0996 17.4939 34.0996 17.6",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 17.2002H35.7V17.6002C35.7 17.7063 35.7421 17.808 35.8172 17.883C35.8922 17.9581 35.9939 18.0002 36.1 18.0002C36.2061 18.0002 36.3078 17.9581 36.3828 17.883C36.4579 17.808 36.5 17.7063 36.5 17.6002",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 18H2.09961V18.8H2.89961V18Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 18.7998V17.9998H4.8998C4.79372 17.9998 4.69198 18.0419 4.61696 18.117C4.54195 18.192 4.4998 18.2937 4.4998 18.3998C4.4998 18.5059 4.54195 18.6076 4.61696 18.6826C4.69198 18.7577 4.79372 18.7998 4.8998 18.7998",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0998 18H5.2998V18.8H6.0998V18Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 18H6.09961V18.8H6.89961V18Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70039 18H6.90039V18.8H7.70039V18Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 18H7.7002V18.8H8.5002V18Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 18H8.5V18.8H9.3V18Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 18V18.8H10.0998V18.4C10.0998 18.2939 10.0577 18.1922 9.98265 18.1172C9.90763 18.0421 9.80589 18 9.6998 18",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3004 18.8C11.5213 18.8 11.7004 18.6209 11.7004 18.4C11.7004 18.1791 11.5213 18 11.3004 18C11.0795 18 10.9004 18.1791 10.9004 18.4C10.9004 18.6209 11.0795 18.8 11.3004 18.8Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 18H12.5V18.8H13.3V18Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 18H13.2998V18.8H14.0998V18Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 18.7998V17.9998H14.9002V18.3998C14.9002 18.5059 14.9423 18.6076 15.0174 18.6826C15.0924 18.7577 15.1941 18.7998 15.3002 18.7998",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 18V18.8H16.5002V18.4C16.5002 18.2939 16.4581 18.1922 16.383 18.1172C16.308 18.0421 16.2063 18 16.1002 18",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1002 18.8C24.3211 18.8 24.5002 18.6209 24.5002 18.4C24.5002 18.1791 24.3211 18 24.1002 18C23.8793 18 23.7002 18.1791 23.7002 18.4C23.7002 18.6209 23.8793 18.8 24.1002 18.8Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 18.7998H27.7004V18.3998C27.7004 18.2937 27.6582 18.192 27.5832 18.117C27.5082 18.0419 27.4065 17.9998 27.3004 17.9998C27.1943 17.9998 27.0926 18.0419 27.0175 18.117C26.9425 18.192 26.9004 18.2937 26.9004 18.3998",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 18H28.5V18.8H29.3V18Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 18H30.9004V18.8H31.7004V18Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 18H31.7002V18.8H32.5002V18Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 18H32.5V18.8H33.3V18Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 18H33.2998V18.8H34.0998V18Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 18H34.0996V18.8H34.8996V18Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 18V18.8H35.3004C35.4065 18.8 35.5082 18.7579 35.5832 18.6828C35.6582 18.6078 35.7004 18.5061 35.7004 18.4C35.7004 18.2939 35.6582 18.1922 35.5832 18.1172C35.5082 18.0421 35.4065 18 35.3004 18",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18.7998H37.3V18.3998C37.3 18.2937 37.2579 18.192 37.1828 18.117C37.1078 18.0419 37.0061 17.9998 36.9 17.9998C36.7939 17.9998 36.6922 18.0419 36.6172 18.117C36.5421 18.192 36.5 18.2937 36.5 18.3998",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 18.7998H2.09961V19.5998H2.89961V18.7998Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0998 18.7998H5.2998V19.5998H6.0998V18.7998Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 18.7998H8.5V19.5998H9.3V18.7998Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 18.7998H9.2998V19.5998H10.0998V18.7998Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 18.7998V19.5998H10.8996V19.1998C10.8996 19.0937 10.8575 18.992 10.7825 18.917C10.7074 18.8419 10.6057 18.7998 10.4996 18.7998",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 18.7998H12.5V19.5998H13.3V18.7998Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 18.7998H13.2998V19.5998H14.0998V18.7998Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 18.7998H15.7002V19.5998H16.5002V18.7998Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.6001H25.3V18.8001H24.9C24.7939 18.8001 24.6922 18.8422 24.6172 18.9173C24.5421 18.9923 24.5 19.094 24.5 19.2001",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 18.7998V19.5998H26.0998V19.1998C26.0998 19.0937 26.0577 18.992 25.9826 18.917C25.9076 18.8419 25.8059 18.7998 25.6998 18.7998",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 18.7998H26.9004V19.5998H27.7004V18.7998Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 18.7998H27.7002V19.5998H28.5002V18.7998Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 18.7998H28.5V19.5998H29.3V18.7998Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 18.7998H30.9004V19.5998H31.7004V18.7998Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 18.7998H34.0996V19.5998H34.8996V18.7998Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 18.7998H36.5V19.5998H37.3V18.7998Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 19.6001H2.09961V20.4001H2.89961V19.6001Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0998 19.6001H5.2998V20.4001H6.0998V19.6001Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30039 20.4001C7.5213 20.4001 7.70039 20.221 7.70039 20.0001C7.70039 19.7792 7.5213 19.6001 7.30039 19.6001C7.07948 19.6001 6.90039 19.7792 6.90039 20.0001C6.90039 20.221 7.07948 20.4001 7.30039 20.4001Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 19.6001H8.5V20.4001H9.3V19.6001Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 19.6001H9.2998V20.4001H10.0998V19.6001Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 19.6001H10.0996V20.4001H10.8996V19.6001Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 19.6001V20.4001H11.7004V20.0001C11.7004 19.894 11.6582 19.7923 11.5832 19.7173C11.5082 19.6422 11.4065 19.6001 11.3004 19.6001",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 20.3999V19.5999H12.4998V19.9999C12.4998 20.106 12.5419 20.2077 12.617 20.2827C12.692 20.3578 12.7937 20.3999 12.8998 20.3999",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 19.6001H13.2998V20.4001H14.0998V19.6001Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 19.6001V20.4001H14.8996V20.0001C14.8996 19.894 14.8575 19.7923 14.7825 19.7173C14.7074 19.6422 14.6057 19.6001 14.4996 19.6001",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.6001H15.7V20.0001C15.7 20.1062 15.7421 20.2079 15.8172 20.2829C15.8922 20.358 15.9939 20.4001 16.1 20.4001C16.2061 20.4001 16.3078 20.358 16.3828 20.2829C16.4579 20.2079 16.5 20.1062 16.5 20.0001",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 19.6001H24.5V20.4001H25.3V19.6001Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 19.6001H25.2998V20.4001H26.0998V19.6001Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 19.6001H26.0996V20.4001H26.8996V19.6001Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 19.6001H26.9004V20.4001H27.7004V19.6001Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 19.6001H28.4998V20.0001C28.4998 20.1062 28.5419 20.2079 28.617 20.2829C28.692 20.358 28.7937 20.4001 28.8998 20.4001C29.0059 20.4001 29.1076 20.358 29.1826 20.2829C29.2577 20.2079 29.2998 20.1062 29.2998 20.0001",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 19.6001H30.9004V20.4001H31.7004V19.6001Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 20.4001C33.1209 20.4001 33.3 20.221 33.3 20.0001C33.3 19.7792 33.1209 19.6001 32.9 19.6001C32.6791 19.6001 32.5 19.7792 32.5 20.0001C32.5 20.221 32.6791 20.4001 32.9 20.4001Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 19.6001H34.0996V20.4001H34.8996V19.6001Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 20.3999H36.5002V19.5999H36.1002C35.9941 19.5999 35.8924 19.642 35.8174 19.7171C35.7423 19.7921 35.7002 19.8938 35.7002 19.9999",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 19.6001H36.5V20.4001H37.3V19.6001Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 19.6001V20.4001H38.0998V20.0001C38.0998 19.894 38.0577 19.7923 37.9826 19.7173C37.9076 19.6422 37.8059 19.6001 37.6998 19.6001",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 20.3999H2.09961V21.1999H2.89961V20.3999Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70039 20.3999H2.90039V21.1999H3.70039V20.3999Z",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7002 20.3999V21.1999H4.1002C4.20628 21.1999 4.30802 21.1578 4.38304 21.0827C4.45805 21.0077 4.5002 20.906 4.5002 20.7999C4.5002 20.6938 4.45805 20.5921 4.38304 20.5171C4.30802 20.442 4.20628 20.3999 4.1002 20.3999",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0998 20.3999H5.2998V21.1999H6.0998V20.3999Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 20.3999H8.5V21.1999H9.3V20.3999Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 20.3999H9.2998V21.1999H10.0998V20.3999Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 20.3999H10.0996V21.1999H10.8996V20.3999Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7004 20.3999H10.9004V21.1999H11.7004V20.3999Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 20.3999V21.1999H12.1002C12.2063 21.1999 12.308 21.1578 12.383 21.0827C12.4581 21.0077 12.5002 20.906 12.5002 20.7999C12.5002 20.6938 12.4581 20.5921 12.383 20.5171C12.308 20.442 12.2063 20.3999 12.1002 20.3999",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 20.3999H13.2998V21.1999H14.0998V20.3999Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8996 20.3999H14.0996V21.1999H14.8996V20.3999Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 20.3999H24.5V21.1999H25.3V20.3999Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 20.3999H25.2998V21.1999H26.0998V20.3999Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 20.3999H26.0996V21.1999H26.8996V20.3999Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 20.3999H26.9004V21.1999H27.7004V20.3999Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 21.2002H30.0998V20.4002H29.6998C29.5937 20.4002 29.492 20.4423 29.417 20.5174C29.3419 20.5924 29.2998 20.6941 29.2998 20.8002",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 20.3999H30.0996V21.1999H30.8996V20.3999Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 20.3999H30.9004V21.1999H31.7004V20.3999Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 20.3999H34.0996V21.1999H34.8996V20.3999Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 20.3999H34.9004V21.1999H35.7004V20.3999Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5002 20.3999H35.7002V21.1999H36.5002V20.3999Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 20.3999H36.5V21.1999H37.3V20.3999Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0998 20.3999H37.2998V21.1999H38.0998V20.3999Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 21.2002H2.09961V22.0002H2.89961V21.2002Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7002 21.2002H2.9002V22.0002H3.3002C3.40628 22.0002 3.50802 21.9581 3.58304 21.883C3.65805 21.808 3.7002 21.7063 3.7002 21.6002",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22H5.3V21.2H4.9C4.79391 21.2 4.69217 21.2421 4.61716 21.3172C4.54214 21.3922 4.5 21.4939 4.5 21.6",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0998 21.2002H5.2998V22.0002H6.0998V21.2002Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 21.2002H6.09961V22.0002H6.89961V21.2002Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70039 21.2002H6.90039V22.0002H7.70039V21.2002Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 21.2002H7.7002V22.0002H8.5002V21.2002Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 21.2002H8.4998V22.0002H8.8998C9.00589 22.0002 9.10763 21.9581 9.18265 21.883C9.25766 21.808 9.2998 21.7063 9.2998 21.6002",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 21.2002H10.0996V22.0002H10.8996V21.2002Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7004 21.2002H10.9004V22.0002H11.7004V21.2002Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 22V21.2H12.8998C12.7937 21.2 12.692 21.2421 12.617 21.3172C12.5419 21.3922 12.4998 21.4939 12.4998 21.6C12.4998 21.7061 12.5419 21.8078 12.617 21.8828C12.692 21.9579 12.7937 22 12.8998 22",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 21.2002H13.2998V22.0002H14.0998V21.2002Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 21.2002H14.1004V22.0002H14.5004C14.6065 22.0002 14.7082 21.9581 14.7832 21.883C14.8582 21.808 14.9004 21.7063 14.9004 21.6002",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 22V21.2H24.4998V21.6C24.4998 21.7061 24.5419 21.8078 24.617 21.8828C24.692 21.9579 24.7937 22 24.8998 22",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 21.2002H25.2996V22.0002H25.6996C25.8057 22.0002 25.9074 21.9581 25.9825 21.883C26.0575 21.808 26.0996 21.7063 26.0996 21.6002",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 22V21.2H26.9002V21.6C26.9002 21.7061 26.9423 21.8078 27.0174 21.8828C27.0924 21.9579 27.1941 22 27.3002 22",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 21.2002V22.0002H28.5002V21.6002C28.5002 21.4941 28.4581 21.3924 28.383 21.3174C28.308 21.2423 28.2063 21.2002 28.1002 21.2002",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 22V21.2H29.2996V21.6C29.2996 21.7061 29.3418 21.8078 29.4168 21.8828C29.4918 21.9579 29.5935 22 29.6996 22",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 21.2002H30.0996V22.0002H30.8996V21.2002Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 21.2002H30.9004V22.0002H31.7004V21.2002Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 21.2002H31.7002V22.0002H32.5002V21.2002Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 21.2002H32.5V22.0002H33.3V21.2002Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 21.2002H33.2998V22.0002H34.0998V21.2002Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 21.2002H34.1004V22.0002H34.5004C34.6065 22.0002 34.7082 21.9581 34.7832 21.883C34.8582 21.808 34.9004 21.7063 34.9004 21.6002",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0998 21.2002H37.2998V22.0002H38.0998V21.2002Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 22H2.09961V22.8H2.89961V22Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 22.7998V21.9998H4.1C3.99391 21.9998 3.89217 22.0419 3.81716 22.117C3.74214 22.192 3.7 22.2937 3.7 22.3998C3.7 22.5059 3.74214 22.6076 3.81716 22.6826C3.89217 22.7577 3.99391 22.7998 4.1 22.7998",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 22H4.5V22.8H5.3V22Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 22H6.09961V22.8H6.89961V22Z",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 22H7.7002V22.8H8.5002V22Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 22.7998H10.0998V21.9998H9.6998C9.59372 21.9998 9.49198 22.0419 9.41696 22.117C9.34195 22.192 9.2998 22.2937 9.2998 22.3998",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 22H10.0996V22.8H10.8996V22Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 22H10.9002V22.8H11.3002C11.4063 22.8 11.508 22.7579 11.583 22.6828C11.6581 22.6078 11.7002 22.5061 11.7002 22.4",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 22H13.2998V22.8H14.0998V22Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 22.7998H15.7004V22.3998C15.7004 22.2937 15.6582 22.192 15.5832 22.117C15.5082 22.0419 15.4065 21.9998 15.3004 21.9998C15.1943 21.9998 15.0926 22.0419 15.0175 22.117C14.9425 22.192 14.9004 22.2937 14.9004 22.3998",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 22.7998H26.8996V22.3998C26.8996 22.2937 26.8575 22.192 26.7825 22.117C26.7074 22.0419 26.6057 21.9998 26.4996 21.9998C26.3935 21.9998 26.2918 22.0419 26.2168 22.117C26.1418 22.192 26.0996 22.2937 26.0996 22.3998",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 22H27.7V22.4C27.7 22.5061 27.7421 22.6078 27.8172 22.6828C27.8922 22.7579 27.9939 22.8 28.1 22.8C28.2061 22.8 28.3078 22.7579 28.3828 22.6828C28.4579 22.6078 28.5 22.5061 28.5 22.4",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 22.7998V21.9998H30.1004V22.3998C30.1004 22.5059 30.1425 22.6076 30.2175 22.6826C30.2926 22.7577 30.3943 22.7998 30.5004 22.7998",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 22H30.9004V22.8H31.7004V22Z",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 22H31.7V22.8H32.1C32.2061 22.8 32.3078 22.7579 32.3828 22.6828C32.4579 22.6078 32.5 22.5061 32.5 22.4",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3004 22.8C35.5213 22.8 35.7004 22.6209 35.7004 22.4C35.7004 22.1791 35.5213 22 35.3004 22C35.0795 22 34.9004 22.1791 34.9004 22.4C34.9004 22.6209 35.0795 22.8 35.3004 22.8Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0996 22H37.2996V22.4C37.2996 22.5061 37.3418 22.6078 37.4168 22.6828C37.4918 22.7579 37.5935 22.8 37.6996 22.8C37.8057 22.8 37.9074 22.7579 37.9825 22.6828C38.0575 22.6078 38.0996 22.5061 38.0996 22.4",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 23.6001V22.8001H2.10039V23.2001C2.10039 23.3062 2.14253 23.4079 2.21755 23.4829C2.29256 23.558 2.3943 23.6001 2.50039 23.6001",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 22.7998V23.5998H3.30039C3.40648 23.5998 3.50822 23.5577 3.58323 23.4826C3.65825 23.4076 3.70039 23.3059 3.70039 23.1998C3.70039 23.0937 3.65825 22.992 3.58323 22.917C3.50822 22.8419 3.40648 22.7998 3.30039 22.7998",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 22.7998H4.5V23.5998H5.3V22.7998Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 22.7998H6.09961V23.5998H6.89961V22.7998Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70039 22.7998H6.90039V23.5998H7.70039V22.7998Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 22.7998H7.7V23.5998H8.1C8.20609 23.5998 8.30783 23.5577 8.38284 23.4826C8.45786 23.4076 8.5 23.3059 8.5 23.1998",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 23.6001V22.8001H9.29961V23.2001C9.29961 23.3062 9.34175 23.4079 9.41677 23.4829C9.49178 23.558 9.59352 23.6001 9.69961 23.6001",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 22.7998H10.1004V23.5998H10.5004C10.6065 23.5998 10.7082 23.5577 10.7832 23.4826C10.8582 23.4076 10.9004 23.3059 10.9004 23.1998",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.6001V22.8001H12.1C11.9939 22.8001 11.8922 22.8422 11.8172 22.9173C11.7421 22.9923 11.7 23.094 11.7 23.2001C11.7 23.3062 11.7421 23.4079 11.8172 23.4829C11.8922 23.558 11.9939 23.6001 12.1 23.6001",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 22.7998H12.5V23.5998H13.3V22.7998Z",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0998 22.7998H13.2998V23.5998H14.0998V22.7998Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 22.7998H14.9004V23.5998H15.7004V22.7998Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 22.7998V23.5998H16.1002C16.2063 23.5998 16.308 23.5577 16.383 23.4826C16.4581 23.4076 16.5002 23.3059 16.5002 23.1998C16.5002 23.0937 16.4581 22.992 16.383 22.917C16.308 22.8419 16.2063 22.7998 16.1002 22.7998",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 23.6001H24.5002V22.8001H24.1002C23.9941 22.8001 23.8924 22.8422 23.8174 22.9173C23.7423 22.9923 23.7002 23.094 23.7002 23.2001",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 22.7998H24.5V23.5998H25.3V22.7998Z",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 22.7998H25.2998V23.5998H26.0998V22.7998Z",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 22.7998H26.0996V23.5998H26.8996V22.7998Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 22.7998V23.5998H27.3004C27.4065 23.5998 27.5082 23.5577 27.5832 23.4826C27.6582 23.4076 27.7004 23.3059 27.7004 23.1998C27.7004 23.0937 27.6582 22.992 27.5832 22.917C27.5082 22.8419 27.4065 22.7998 27.3004 22.7998",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6998 23.5998C29.9207 23.5998 30.0998 23.4207 30.0998 23.1998C30.0998 22.9789 29.9207 22.7998 29.6998 22.7998C29.4789 22.7998 29.2998 22.9789 29.2998 23.1998C29.2998 23.4207 29.4789 23.5998 29.6998 23.5998Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6998 23.5998C33.9207 23.5998 34.0998 23.4207 34.0998 23.1998C34.0998 22.9789 33.9207 22.7998 33.6998 22.7998C33.4789 22.7998 33.2998 22.9789 33.2998 23.1998C33.2998 23.4207 33.4789 23.5998 33.6998 23.5998Z",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 23.6001H37.3V23.2001C37.3 23.094 37.2579 22.9923 37.1828 22.9173C37.1078 22.8422 37.0061 22.8001 36.9 22.8001C36.7939 22.8001 36.6922 22.8422 36.6172 22.9173C36.5421 22.9923 36.5 23.094 36.5 23.2001",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 23.6001H4.4998V24.0001C4.4998 24.1062 4.54195 24.2079 4.61696 24.2829C4.69198 24.358 4.79372 24.4001 4.8998 24.4001C5.00589 24.4001 5.10763 24.358 5.18265 24.2829C5.25766 24.2079 5.2998 24.1062 5.2998 24.0001",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 23.6001H6.09961V24.4001H6.89961V23.6001Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 24.3999V23.5999H12.4998V23.9999C12.4998 24.106 12.5419 24.2077 12.617 24.2827C12.692 24.3578 12.7937 24.3999 12.8998 24.3999",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 23.6001H13.2996V24.4001H13.6996C13.8057 24.4001 13.9074 24.358 13.9825 24.2829C14.0575 24.2079 14.0996 24.1062 14.0996 24.0001",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 23.6001H14.9004V24.4001H15.7004V23.6001Z",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 24.4001C17.1209 24.4001 17.3 24.221 17.3 24.0001C17.3 23.7792 17.1209 23.6001 16.9 23.6001C16.6791 23.6001 16.5 23.7792 16.5 24.0001C16.5 24.221 16.6791 24.4001 16.9 24.4001Z",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4996 24.4001C18.7205 24.4001 18.8996 24.221 18.8996 24.0001C18.8996 23.7792 18.7205 23.6001 18.4996 23.6001C18.2787 23.6001 18.0996 23.7792 18.0996 24.0001C18.0996 24.221 18.2787 24.4001 18.4996 24.4001Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 24.3999H20.5002V23.9999C20.5002 23.8938 20.4581 23.7921 20.383 23.7171C20.308 23.642 20.2063 23.5999 20.1002 23.5999C19.9941 23.5999 19.8924 23.642 19.8174 23.7171C19.7423 23.7921 19.7002 23.8938 19.7002 23.9999",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.6001H23.7V24.0001C23.7 24.1062 23.7421 24.2079 23.8172 24.2829C23.8922 24.358 23.9939 24.4001 24.1 24.4001C24.2061 24.4001 24.3078 24.358 24.3828 24.2829C24.4579 24.2079 24.5 24.1062 24.5 24.0001",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 23.6001H25.2998V24.4001H26.0998V23.6001Z",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 23.6001H26.1004V24.4001H26.5004C26.6065 24.4001 26.7082 24.358 26.7832 24.2829C26.8582 24.2079 26.9004 24.1062 26.9004 24.0001",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 24.3999V23.5999H28.1C27.9939 23.5999 27.8922 23.642 27.8172 23.7171C27.7421 23.7921 27.7 23.8938 27.7 23.9999C27.7 24.106 27.7421 24.2077 27.8172 24.2827C27.8922 24.3578 27.9939 24.3999 28.1 24.3999",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 23.6001V24.4001H29.3V24.0001C29.3 23.894 29.2579 23.7923 29.1828 23.7173C29.1078 23.6422 29.0061 23.6001 28.9 23.6001",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3004 24.4001C31.5213 24.4001 31.7004 24.221 31.7004 24.0001C31.7004 23.7792 31.5213 23.6001 31.3004 23.6001C31.0795 23.6001 30.9004 23.7792 30.9004 24.0001C30.9004 24.221 31.0795 24.4001 31.3004 24.4001Z",
    fill: "white"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0996 24.3999H34.8996V23.5999H34.4996C34.3935 23.5999 34.2918 23.642 34.2168 23.7171C34.1418 23.7921 34.0996 23.8938 34.0996 23.9999",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 23.6001V24.4001H35.7004V24.0001C35.7004 23.894 35.6582 23.7923 35.5832 23.7173C35.5082 23.6422 35.4065 23.6001 35.3004 23.6001",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 24.3999V23.5999H36.4998V23.9999C36.4998 24.106 36.5419 24.2077 36.617 24.2827C36.692 24.3578 36.7937 24.3999 36.8998 24.3999",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 23.6001V24.4001H38.0998V24.0001C38.0998 23.894 38.0577 23.7923 37.9826 23.7173C37.9076 23.6422 37.8059 23.6001 37.6998 23.6001",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 25.2002H3.70039V24.4002H3.30039C3.1943 24.4002 3.09256 24.4423 3.01755 24.5174C2.94253 24.5924 2.90039 24.6941 2.90039 24.8002",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7002 24.3999V25.1999H4.5002V24.7999C4.5002 24.6938 4.45805 24.5921 4.38304 24.5171C4.30802 24.442 4.20628 24.3999 4.1002 24.3999",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 24.3999H6.09961V25.1999H6.89961V24.3999Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70039 24.3999H6.90039V25.1999H7.70039V24.3999Z",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 24.3999H7.7002V25.1999H8.5002V24.3999Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 24.3999H8.5V25.1999H9.3V24.3999Z",
    fill: "white"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 24.3999V25.1999H10.0998V24.7999C10.0998 24.6938 10.0577 24.5921 9.98265 24.5171C9.90763 24.442 9.80589 24.3999 9.6998 24.3999",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 25.2002H11.7004V24.8002C11.7004 24.6941 11.6582 24.5924 11.5832 24.5174C11.5082 24.4423 11.4065 24.4002 11.3004 24.4002C11.1943 24.4002 11.0926 24.4423 11.0175 24.5174C10.9425 24.5924 10.9004 24.6941 10.9004 24.8002",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 24.3999H14.9004V25.1999H15.7004V24.3999Z",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 24.3999V25.1999H16.1002C16.2063 25.1999 16.308 25.1578 16.383 25.0827C16.4581 25.0077 16.5002 24.906 16.5002 24.7999C16.5002 24.6938 16.4581 24.5921 16.383 24.5171C16.308 24.442 16.2063 24.3999 16.1002 24.3999",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 24.3999H19.7002V25.1999H20.5002V24.3999Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 25.2002H22.0998V24.8002C22.0998 24.6941 22.0577 24.5924 21.9826 24.5174C21.9076 24.4423 21.8059 24.4002 21.6998 24.4002C21.5937 24.4002 21.492 24.4423 21.417 24.5174C21.3419 24.5924 21.2998 24.6941 21.2998 24.8002",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 25.2002H23.7004V24.8002C23.7004 24.6941 23.6582 24.5924 23.5832 24.5174C23.5082 24.4423 23.4065 24.4002 23.3004 24.4002C23.1943 24.4002 23.0926 24.4423 23.0175 24.5174C22.9425 24.5924 22.9004 24.6941 22.9004 24.8002",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 24.3999H25.2996V24.7999C25.2996 24.906 25.3418 25.0077 25.4168 25.0827C25.4918 25.1578 25.5935 25.1999 25.6996 25.1999C25.8057 25.1999 25.9074 25.1578 25.9825 25.0827C26.0575 25.0077 26.0996 24.906 26.0996 24.7999",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3004 25.1999C27.5213 25.1999 27.7004 25.0208 27.7004 24.7999C27.7004 24.579 27.5213 24.3999 27.3004 24.3999C27.0795 24.3999 26.9004 24.579 26.9004 24.7999C26.9004 25.0208 27.0795 25.1999 27.3004 25.1999Z",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 24.3999H28.5V25.1999H29.3V24.3999Z",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 24.3999H29.2998V25.1999H30.0998V24.3999Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 24.3999V25.1999H30.8996V24.7999C30.8996 24.6938 30.8575 24.5921 30.7825 24.5171C30.7074 24.442 30.6057 24.3999 30.4996 24.3999",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2998 25.2002V24.4002H32.8998C32.7937 24.4002 32.692 24.4423 32.617 24.5174C32.5419 24.5924 32.4998 24.6941 32.4998 24.8002C32.4998 24.9063 32.5419 25.008 32.617 25.083C32.692 25.1581 32.7937 25.2002 32.8998 25.2002",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 24.3999H33.2998V25.1999H34.0998V24.3999Z",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 24.3999H34.0996V25.1999H34.8996V24.3999Z",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 24.3999H34.9004V25.1999H35.7004V24.3999Z",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 24.3999V25.1999H36.5002V24.7999C36.5002 24.6938 36.4581 24.5921 36.383 24.5171C36.308 24.442 36.2063 24.3999 36.1002 24.3999",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0998 24.3999H37.2998V25.1999H38.0998V24.3999Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09961 26H2.89961V25.2H2.49961C2.39352 25.2 2.29178 25.2421 2.21677 25.3172C2.14175 25.3922 2.09961 25.4939 2.09961 25.6",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70039 25.2002H2.90039V26.0002H3.70039V25.2002Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5002 25.2002H3.7002V26.0002H4.5002V25.2002Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 25.2002V26.0002H5.3V25.6002C5.3 25.4941 5.25786 25.3924 5.18284 25.3174C5.10783 25.2423 5.00609 25.2002 4.9 25.2002",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 25.2002H6.09961V26.0002H6.89961V25.2002Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 25.2002H7.7002V26.0002H8.5002V25.2002Z",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 25.2002H9.2998V26.0002H10.0998V25.2002Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7004 25.2002H10.9004V26.0002H11.7004V25.2002Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 26H13.3V25.6C13.3 25.4939 13.2579 25.3922 13.1828 25.3172C13.1078 25.2421 13.0061 25.2 12.9 25.2C12.7939 25.2 12.6922 25.2421 12.6172 25.3172C12.5421 25.3922 12.5 25.4939 12.5 25.6",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 26H14.8996V25.2H14.4996C14.3935 25.2 14.2918 25.2421 14.2168 25.3172C14.1418 25.3922 14.0996 25.4939 14.0996 25.6",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 25.2002H14.9002V26.0002H15.3002C15.4063 26.0002 15.508 25.9581 15.583 25.883C15.6581 25.808 15.7002 25.7063 15.7002 25.6002",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26H17.3V25.6C17.3 25.4939 17.2579 25.3922 17.1828 25.3172C17.1078 25.2421 17.0061 25.2 16.9 25.2C16.7939 25.2 16.6922 25.2421 16.6172 25.3172C16.5421 25.3922 16.5 25.4939 16.5 25.6",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 25.2002H19.7002V26.0002H20.5002V25.2002Z",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 26V25.2H21.2996V25.6C21.2996 25.7061 21.3418 25.8078 21.4168 25.8828C21.4918 25.9579 21.5935 26 21.6996 26",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8996 25.2002H22.0996V26.0002H22.8996V25.2002Z",
    fill: "white"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7004 25.2002H22.9004V26.0002H23.7004V25.2002Z",
    fill: "white"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 25.2002V26.0002H24.5002V25.6002C24.5002 25.4941 24.4581 25.3924 24.383 25.3174C24.308 25.2423 24.2063 25.2002 24.1002 25.2002",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4996 26.0002C26.7205 26.0002 26.8996 25.8211 26.8996 25.6002C26.8996 25.3793 26.7205 25.2002 26.4996 25.2002C26.2787 25.2002 26.0996 25.3793 26.0996 25.6002C26.0996 25.8211 26.2787 26.0002 26.4996 26.0002Z",
    fill: "white"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 26V25.2H28.1C27.9939 25.2 27.8922 25.2421 27.8172 25.3172C27.7421 25.3922 27.7 25.4939 27.7 25.6C27.7 25.7061 27.7421 25.8078 27.8172 25.8828C27.8922 25.9579 27.9939 26 28.1 26",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 25.2002H28.5V26.0002H29.3V25.2002Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 25.2002H29.2998V26.0002H30.0998V25.2002Z",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 25.2002H30.0996V26.0002H30.8996V25.2002Z",
    fill: "white"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 25.2002H30.9004V26.0002H31.7004V25.2002Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 25.2002V26.0002H32.5002V25.6002C32.5002 25.4941 32.4581 25.3924 32.383 25.3174C32.308 25.2423 32.2063 25.2002 32.1002 25.2002",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 25.2002H34.0996V26.0002H34.8996V25.2002Z",
    fill: "white"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 25.2002H34.9004V26.0002H35.7004V25.2002Z",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5002 25.2002H35.7002V26.0002H36.5002V25.2002Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 25.2002H36.5V26.0002H37.3V25.2002Z",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0998 25.2002H37.2998V26.0002H38.0998V25.2002Z",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 26H2.09961V26.8H2.89961V26Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70039 26H2.90039V26.8H3.70039V26Z",
    fill: "white"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 26H4.4998V26.4C4.4998 26.5061 4.54195 26.6078 4.61696 26.6828C4.69198 26.7579 4.79372 26.8 4.8998 26.8C5.00589 26.8 5.10763 26.7579 5.18265 26.6828C5.25766 26.6078 5.2998 26.5061 5.2998 26.4",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 26H6.09961V26.8H6.89961V26Z",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70039 26H6.90039V26.8H7.70039V26Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 26H7.7002V26.8H8.5002V26Z",
    fill: "white"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 26.7998V25.9998H9.29961V26.3998C9.29961 26.5059 9.34175 26.6076 9.41677 26.6826C9.49178 26.7577 9.59352 26.7998 9.69961 26.7998",
    fill: "white"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 26H10.0996V26.8H10.8996V26Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7004 26H10.9004V26.8H11.7004V26Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 26H11.7002V26.8H12.5002V26Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 26H12.5V26.8H13.3V26Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8996 26H14.0996V26.8H14.8996V26Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 26H16.4998V26.4C16.4998 26.5061 16.5419 26.6078 16.617 26.6828C16.692 26.7579 16.7937 26.8 16.8998 26.8C17.0059 26.8 17.1076 26.7579 17.1826 26.6828C17.2577 26.6078 17.2998 26.5061 17.2998 26.4",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4996 26.8C18.7205 26.8 18.8996 26.6209 18.8996 26.4C18.8996 26.1791 18.7205 26 18.4996 26C18.2787 26 18.0996 26.1791 18.0996 26.4C18.0996 26.6209 18.2787 26.8 18.4996 26.8Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26H19.7V26.4C19.7 26.5061 19.7421 26.6078 19.8172 26.6828C19.8922 26.7579 19.9939 26.8 20.1 26.8C20.2061 26.8 20.3078 26.7579 20.3828 26.6828C20.4579 26.6078 20.5 26.5061 20.5 26.4",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8996 26H22.0996V26.8H22.8996V26Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 26H23.7002V26.8H24.5002V26Z",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 26H24.5V26.8H25.3V26Z",
    fill: "white"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 26V26.8H26.0998V26.4C26.0998 26.2939 26.0577 26.1922 25.9826 26.1172C25.9076 26.0421 25.8059 26 25.6998 26",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 26H29.2998V26.8H30.0998V26Z",
    fill: "white"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 26H30.0996V26.8H30.8996V26Z",
    fill: "white"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 26H30.9004V26.8H31.7004V26Z",
    fill: "white"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 26H31.7002V26.8H32.5002V26Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 26V26.8H33.3V26.4C33.3 26.2939 33.2579 26.1922 33.1828 26.1172C33.1078 26.0421 33.0061 26 32.9 26",
    fill: "white"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 26H34.0996V26.8H34.8996V26Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5002 26H35.7002V26.8H36.5002V26Z",
    fill: "white"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0996 26H37.2996V26.4C37.2996 26.5061 37.3418 26.6078 37.4168 26.6828C37.4918 26.7579 37.5935 26.8 37.6996 26.8C37.8057 26.8 37.9074 26.7579 37.9825 26.6828C38.0575 26.6078 38.0996 26.5061 38.0996 26.4",
    fill: "white"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89961 26.7998H2.09961V27.5998H2.89961V26.7998Z",
    fill: "white"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70039 26.7998H2.90039V27.5998H3.70039V26.7998Z",
    fill: "white"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 27.6001V26.8001H5.69961C5.59352 26.8001 5.49178 26.8422 5.41677 26.9173C5.34175 26.9923 5.29961 27.094 5.29961 27.2001C5.29961 27.3062 5.34175 27.4079 5.41677 27.4829C5.49178 27.558 5.59352 27.6001 5.69961 27.6001",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 26.7998H6.09961V27.5998H6.89961V26.7998Z",
    fill: "white"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 27.6001V26.8001H7.7V27.2001C7.7 27.3062 7.74214 27.4079 7.81716 27.4829C7.89217 27.558 7.99391 27.6001 8.1 27.6001",
    fill: "white"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 26.7998V27.5998H9.3V27.1998C9.3 27.0937 9.25786 26.992 9.18284 26.917C9.10783 26.8419 9.00609 26.7998 8.9 26.7998",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 26.7998H11.7002V27.5998H12.5002V26.7998Z",
    fill: "white"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 26.7998H12.5V27.5998H13.3V26.7998Z",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8996 26.7998H14.0996V27.5998H14.8996V26.7998Z",
    fill: "white"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 27.6001H19.7004V27.2001C19.7004 27.094 19.6582 26.9923 19.5832 26.9173C19.5082 26.8422 19.4065 26.8001 19.3004 26.8001C19.1943 26.8001 19.0926 26.8422 19.0175 26.9173C18.9425 26.9923 18.9004 27.094 18.9004 27.2001",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 27.5998C21.1209 27.5998 21.3 27.4207 21.3 27.1998C21.3 26.9789 21.1209 26.7998 20.9 26.7998C20.6791 26.7998 20.5 26.9789 20.5 27.1998C20.5 27.4207 20.6791 27.5998 20.9 27.5998Z",
    fill: "white"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9004 27.6001V26.8001H22.1004V27.2001C22.1004 27.3062 22.1425 27.4079 22.2175 27.4829C22.2926 27.558 22.3943 27.6001 22.5004 27.6001",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7004 26.7998H22.9004V27.5998H23.7004V26.7998Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 26.7998H23.7002V27.5998H24.5002V26.7998Z",
    fill: "white"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 26.7998H24.5V27.5998H25.3V26.7998Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 26.7998H25.2998V27.5998H26.0998V26.7998Z",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 26.7998V27.5998H26.8996V27.1998C26.8996 27.0937 26.8575 26.992 26.7825 26.917C26.7074 26.8419 26.6057 26.7998 26.4996 26.7998",
    fill: "white"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1002 27.5998C28.3211 27.5998 28.5002 27.4207 28.5002 27.1998C28.5002 26.9789 28.3211 26.7998 28.1002 26.7998C27.8793 26.7998 27.7002 26.9789 27.7002 27.1998C27.7002 27.4207 27.8793 27.5998 28.1002 27.5998Z",
    fill: "white"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 26.7998H29.2996V27.1998C29.2996 27.3059 29.3418 27.4076 29.4168 27.4826C29.4918 27.5577 29.5935 27.5998 29.6996 27.5998C29.8057 27.5998 29.9074 27.5577 29.9825 27.4826C30.0575 27.4076 30.0996 27.3059 30.0996 27.1998",
    fill: "white"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 26.7998H32.5V27.5998H33.3V26.7998Z",
    fill: "white"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 26.7998H34.0996V27.5998H34.8996V26.7998Z",
    fill: "white"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5002 26.7998H35.7002V27.5998H36.5002V26.7998Z",
    fill: "white"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 26.7998V27.5998H37.3V27.1998C37.3 27.0937 37.2579 26.992 37.1828 26.917C37.1078 26.8419 37.0061 26.7998 36.9 26.7998",
    fill: "white"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 28.3999V27.5999H2.10039V27.9999C2.10039 28.106 2.14253 28.2077 2.21755 28.2827C2.29256 28.3578 2.3943 28.3999 2.50039 28.3999",
    fill: "white"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70039 27.6001H2.90039V28.4001H3.70039V27.6001Z",
    fill: "white"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9 28.4001C5.12091 28.4001 5.3 28.221 5.3 28.0001C5.3 27.7792 5.12091 27.6001 4.9 27.6001C4.67909 27.6001 4.5 27.7792 4.5 28.0001C4.5 28.221 4.67909 28.4001 4.9 28.4001Z",
    fill: "white"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89961 27.6001H6.09961V28.4001H6.89961V27.6001Z",
    fill: "white"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 27.6001V28.4001H7.30039C7.40648 28.4001 7.50822 28.358 7.58323 28.2829C7.65825 28.2079 7.70039 28.1062 7.70039 28.0001C7.70039 27.894 7.65825 27.7923 7.58323 27.7173C7.50822 27.6422 7.40648 27.6001 7.30039 27.6001",
    fill: "white"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 27.6001H8.5V28.4001H9.3V27.6001Z",
    fill: "white"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 28.3999H10.8996V27.9999C10.8996 27.8938 10.8575 27.7921 10.7825 27.7171C10.7074 27.642 10.6057 27.5999 10.4996 27.5999C10.3935 27.5999 10.2918 27.642 10.2168 27.7171C10.1418 27.7921 10.0996 27.8938 10.0996 27.9999",
    fill: "white"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 28.3999V27.5999H11.7V27.9999C11.7 28.106 11.7421 28.2077 11.8172 28.2827C11.8922 28.3578 11.9939 28.3999 12.1 28.3999",
    fill: "white"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 27.6001H12.5V28.4001H13.3V27.6001Z",
    fill: "white"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 28.3999V27.5999H14.1004V27.9999C14.1004 28.106 14.1425 28.2077 14.2175 28.2827C14.2926 28.3578 14.3943 28.3999 14.5004 28.3999",
    fill: "white"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 27.6001H14.9004V28.4001H15.7004V27.6001Z",
    fill: "white"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 27.6001V28.4001H16.1002C16.2063 28.4001 16.308 28.358 16.383 28.2829C16.4581 28.2079 16.5002 28.1062 16.5002 28.0001C16.5002 27.894 16.4581 27.7923 16.383 27.7173C16.308 27.6422 16.2063 27.6001 16.1002 27.6001",
    fill: "white"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0996 28.3999H18.8996V27.5999H18.4996C18.3935 27.5999 18.2918 27.642 18.2168 27.7171C18.1418 27.7921 18.0996 27.8938 18.0996 27.9999",
    fill: "white"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 27.6001H18.9002V28.4001H19.3002C19.4063 28.4001 19.508 28.358 19.583 28.2829C19.6581 28.2079 19.7002 28.1062 19.7002 28.0001",
    fill: "white"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 27.6001H23.7002V28.4001H24.5002V27.6001Z",
    fill: "white"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 27.6001H24.5V28.4001H25.3V27.6001Z",
    fill: "white"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 27.6001H25.2998V28.4001H26.0998V27.6001Z",
    fill: "white"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 27.6001H26.0996V28.4001H26.8996V27.6001Z",
    fill: "white"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 28.4001C29.1209 28.4001 29.3 28.221 29.3 28.0001C29.3 27.7792 29.1209 27.6001 28.9 27.6001C28.6791 27.6001 28.5 27.7792 28.5 28.0001C28.5 28.221 28.6791 28.4001 28.9 28.4001Z",
    fill: "white"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 28.3999H30.8996V27.5999H30.4996C30.3935 27.5999 30.2918 27.642 30.2168 27.7171C30.1418 27.7921 30.0996 27.8938 30.0996 27.9999",
    fill: "white"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 27.6001V28.4001H31.3004C31.4065 28.4001 31.5082 28.358 31.5832 28.2829C31.6582 28.2079 31.7004 28.1062 31.7004 28.0001C31.7004 27.894 31.6582 27.7923 31.5832 27.7173C31.5082 27.6422 31.4065 27.6001 31.3004 27.6001",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2998 28.3999V27.5999H32.4998V27.9999C32.4998 28.106 32.5419 28.2077 32.617 28.2827C32.692 28.3578 32.7937 28.3999 32.8998 28.3999",
    fill: "white"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 27.6001H33.2998V28.4001H34.0998V27.6001Z",
    fill: "white"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 27.6001H34.0996V28.4001H34.8996V27.6001Z",
    fill: "white"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 27.6001H34.9004V28.4001H35.7004V27.6001Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5002 27.6001H35.7002V28.4001H36.5002V27.6001Z",
    fill: "white"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 27.6001H36.4998V28.4001H36.8998C37.0059 28.4001 37.1076 28.358 37.1826 28.2829C37.2577 28.2079 37.2998 28.1062 37.2998 28.0001",
    fill: "white"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7002 28.3999H2.9002V28.7999C2.9002 28.906 2.94234 29.0077 3.01735 29.0827C3.09237 29.1578 3.19411 29.1999 3.3002 29.1999C3.40628 29.1999 3.50802 29.1578 3.58304 29.0827C3.65805 29.0077 3.7002 28.906 3.7002 28.7999",
    fill: "white"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 29.2002H6.0998V28.4002H5.6998C5.59372 28.4002 5.49198 28.4423 5.41696 28.5174C5.34195 28.5924 5.2998 28.6941 5.2998 28.8002",
    fill: "white"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 28.3999H6.10039V29.1999H6.50039C6.60648 29.1999 6.70822 29.1578 6.78323 29.0827C6.85825 29.0077 6.90039 28.906 6.90039 28.7999",
    fill: "white"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 29.2002V28.4002H8.1C7.99391 28.4002 7.89217 28.4423 7.81716 28.5174C7.74214 28.5924 7.7 28.6941 7.7 28.8002C7.7 28.9063 7.74214 29.008 7.81716 29.083C7.89217 29.1581 7.99391 29.2002 8.1 29.2002",
    fill: "white"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 28.3999H8.4998V29.1999H8.8998C9.00589 29.1999 9.10763 29.1578 9.18265 29.0827C9.25766 29.0077 9.2998 28.906 9.2998 28.7999",
    fill: "white"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 28.3999H10.0996V29.1999H10.8996V28.3999Z",
    fill: "white"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 28.3999V29.1999H11.3004C11.4065 29.1999 11.5082 29.1578 11.5832 29.0827C11.6582 29.0077 11.7004 28.906 11.7004 28.7999C11.7004 28.6938 11.6582 28.5921 11.5832 28.5171C11.5082 28.442 11.4065 28.3999 11.3004 28.3999",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 29.2002V28.4002H12.4998V28.8002C12.4998 28.9063 12.5419 29.008 12.617 29.083C12.692 29.1581 12.7937 29.2002 12.8998 29.2002",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 28.3999V29.1999H13.6998C13.8059 29.1999 13.9076 29.1578 13.9826 29.0827C14.0577 29.0077 14.0998 28.906 14.0998 28.7999C14.0998 28.6938 14.0577 28.5921 13.9826 28.5171C13.9076 28.442 13.8059 28.3999 13.6998 28.3999",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 28.3999H18.1004V28.7999C18.1004 28.906 18.1425 29.0077 18.2175 29.0827C18.2926 29.1578 18.3943 29.1999 18.5004 29.1999C18.6065 29.1999 18.7082 29.1578 18.7832 29.0827C18.8582 29.0077 18.9004 28.906 18.9004 28.7999",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 29.2002H21.3V28.8002C21.3 28.6941 21.2579 28.5924 21.1828 28.5174C21.1078 28.4423 21.0061 28.4002 20.9 28.4002C20.7939 28.4002 20.6922 28.4423 20.6172 28.5174C20.5421 28.5924 20.5 28.6941 20.5 28.8002",
    fill: "white"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 29.2002V28.4002H23.3002C23.1941 28.4002 23.0924 28.4423 23.0174 28.5174C22.9423 28.5924 22.9002 28.6941 22.9002 28.8002C22.9002 28.9063 22.9423 29.008 23.0174 29.083C23.0924 29.1581 23.1941 29.2002 23.3002 29.2002",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 28.3999H23.7002V29.1999H24.5002V28.3999Z",
    fill: "white"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 28.3999H26.0996V29.1999H26.8996V28.3999Z",
    fill: "white"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 28.3999H26.9004V29.1999H27.7004V28.3999Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 28.3999V29.1999H28.5002V28.7999C28.5002 28.6938 28.4581 28.5921 28.383 28.5171C28.308 28.442 28.2063 28.3999 28.1002 28.3999",
    fill: "white"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 29.2002H30.0998V28.4002H29.6998C29.5937 28.4002 29.492 28.4423 29.417 28.5174C29.3419 28.5924 29.2998 28.6941 29.2998 28.8002",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 28.3999H30.1004V29.1999H30.5004C30.6065 29.1999 30.7082 29.1578 30.7832 29.0827C30.8582 29.0077 30.9004 28.906 30.9004 28.7999",
    fill: "white"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 28.3999H33.2998V29.1999H34.0998V28.3999Z",
    fill: "white"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 28.3999H35.7V28.7999C35.7 28.906 35.7421 29.0077 35.8172 29.0827C35.8922 29.1578 35.9939 29.1999 36.1 29.1999C36.2061 29.1999 36.3078 29.1578 36.3828 29.0827C36.4579 29.0077 36.5 28.906 36.5 28.7999",
    fill: "white"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0998 29.2002H5.2998V30.0002H6.0998V29.2002Z",
    fill: "white"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30039 30.0002C7.5213 30.0002 7.70039 29.8211 7.70039 29.6002C7.70039 29.3793 7.5213 29.2002 7.30039 29.2002C7.07948 29.2002 6.90039 29.3793 6.90039 29.6002C6.90039 29.8211 7.07948 30.0002 7.30039 30.0002Z",
    fill: "white"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 30H10.0998V29.2H9.6998C9.59372 29.2 9.49198 29.2421 9.41696 29.3172C9.34195 29.3922 9.2998 29.4939 9.2998 29.6",
    fill: "white"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 29.2002H10.0996V30.0002H10.8996V29.2002Z",
    fill: "white"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 30H12.5002V29.6C12.5002 29.4939 12.4581 29.3922 12.383 29.3172C12.308 29.2421 12.2063 29.2 12.1002 29.2C11.9941 29.2 11.8924 29.2421 11.8174 29.3172C11.7423 29.3922 11.7002 29.4939 11.7002 29.6",
    fill: "white"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 30H14.8996V29.2H14.4996C14.3935 29.2 14.2918 29.2421 14.2168 29.3172C14.1418 29.3922 14.0996 29.4939 14.0996 29.6",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 29.2002H14.9004V30.0002H15.7004V29.2002Z",
    fill: "white"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 29.2002V30.0002H16.5002V29.6002C16.5002 29.4941 16.4581 29.3924 16.383 29.3174C16.308 29.2423 16.2063 29.2002 16.1002 29.2002",
    fill: "white"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3004 30.0002C19.5213 30.0002 19.7004 29.8211 19.7004 29.6002C19.7004 29.3793 19.5213 29.2002 19.3004 29.2002C19.0795 29.2002 18.9004 29.3793 18.9004 29.6002C18.9004 29.8211 19.0795 30.0002 19.3004 30.0002Z",
    fill: "white"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 30V29.2H20.4998V29.6C20.4998 29.7061 20.5419 29.8078 20.617 29.8828C20.692 29.9579 20.7937 30 20.8998 30",
    fill: "white"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2998 29.2002V30.0002H21.6998C21.8059 30.0002 21.9076 29.9581 21.9826 29.883C22.0577 29.808 22.0998 29.7063 22.0998 29.6002C22.0998 29.4941 22.0577 29.3924 21.9826 29.3174C21.9076 29.2423 21.8059 29.2002 21.6998 29.2002",
    fill: "white"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 29.2002H23.7002V30.0002H24.5002V29.2002Z",
    fill: "white"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 29.2002H24.5V30.0002H25.3V29.2002Z",
    fill: "white"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 29.2002H25.2998V30.0002H26.0998V29.2002Z",
    fill: "white"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 29.2002H26.0996V30.0002H26.8996V29.2002Z",
    fill: "white"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 29.2002H26.9004V30.0002H27.7004V29.2002Z",
    fill: "white"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 29.2002H27.7002V30.0002H28.5002V29.2002Z",
    fill: "white"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 29.2002H29.2998V30.0002H30.0998V29.2002Z",
    fill: "white"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 30H31.7004V29.2H31.3004C31.1943 29.2 31.0926 29.2421 31.0175 29.3172C30.9425 29.3922 30.9004 29.4939 30.9004 29.6",
    fill: "white"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 29.2002V30.0002H32.1002C32.2063 30.0002 32.308 29.9581 32.383 29.883C32.4581 29.808 32.5002 29.7063 32.5002 29.6002C32.5002 29.4941 32.4581 29.3924 32.383 29.3174C32.308 29.2423 32.2063 29.2002 32.1002 29.2002",
    fill: "white"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 29.2002H33.2998V30.0002H34.0998V29.2002Z",
    fill: "white"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 29.2002H34.0996V30.0002H34.8996V29.2002Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 29.2002V30.0002H35.3004C35.4065 30.0002 35.5082 29.9581 35.5832 29.883C35.6582 29.808 35.7004 29.7063 35.7004 29.6002C35.7004 29.4941 35.6582 29.3924 35.5832 29.3174C35.5082 29.2423 35.4065 29.2002 35.3004 29.2002",
    fill: "white"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6998 30.0002C37.9207 30.0002 38.0998 29.8211 38.0998 29.6002C38.0998 29.3793 37.9207 29.2002 37.6998 29.2002C37.4789 29.2002 37.2998 29.3793 37.2998 29.6002C37.2998 29.8211 37.4789 30.0002 37.6998 30.0002Z",
    fill: "white"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7002 30.7998V29.9998H3.3002C3.19411 29.9998 3.09237 30.0419 3.01735 30.117C2.94234 30.192 2.9002 30.2937 2.9002 30.3998C2.9002 30.5059 2.94234 30.6076 3.01735 30.6826C3.09237 30.7577 3.19411 30.7998 3.3002 30.7998",
    fill: "white"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5002 30H3.7002V30.8H4.5002V30Z",
    fill: "white"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 30H4.5V30.8H5.3V30Z",
    fill: "white"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0998 30H5.2998V30.8H6.0998V30Z",
    fill: "white"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 30H9.2998V30.8H10.0998V30Z",
    fill: "white"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 30H10.1004V30.8H10.5004C10.6065 30.8 10.7082 30.7579 10.7832 30.6828C10.8582 30.6078 10.9004 30.5061 10.9004 30.4",
    fill: "white"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 30H11.7002V30.8H12.5002V30Z",
    fill: "white"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 30V30.8H13.3V30.4C13.3 30.2939 13.2579 30.1922 13.1828 30.1172C13.1078 30.0421 13.0061 30 12.9 30",
    fill: "white"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 30.7998V29.9998H14.1004V30.3998C14.1004 30.5059 14.1425 30.6076 14.2175 30.6826C14.2926 30.7577 14.3943 30.7998 14.5004 30.7998",
    fill: "white"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 30H14.9004V30.8H15.7004V30Z",
    fill: "white"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 30H15.7V30.8H16.1C16.2061 30.8 16.3078 30.7579 16.3828 30.6828C16.4579 30.6078 16.5 30.5061 16.5 30.4",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 30.7998H22.8996V30.3998C22.8996 30.2937 22.8575 30.192 22.7825 30.117C22.7074 30.0419 22.6057 29.9998 22.4996 29.9998C22.3935 29.9998 22.2918 30.0419 22.2168 30.117C22.1418 30.192 22.0996 30.2937 22.0996 30.3998",
    fill: "white"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 30H23.7002V30.8H24.5002V30Z",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 30H24.5V30.8H25.3V30Z",
    fill: "white"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 30H26.9004V30.8H27.7004V30Z",
    fill: "white"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 30H27.7002V30.8H28.5002V30Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 30H29.2996V30.4C29.2996 30.5061 29.3418 30.6078 29.4168 30.6828C29.4918 30.7579 29.5935 30.8 29.6996 30.8C29.8057 30.8 29.9074 30.7579 29.9825 30.6828C30.0575 30.6078 30.0996 30.5061 30.0996 30.4",
    fill: "white"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 30H30.9004V30.8H31.7004V30Z",
    fill: "white"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 30H33.2998V30.8H34.0998V30Z",
    fill: "white"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1002 30.8C36.3211 30.8 36.5002 30.6209 36.5002 30.4C36.5002 30.1791 36.3211 30 36.1002 30C35.8793 30 35.7002 30.1791 35.7002 30.4C35.7002 30.6209 35.8793 30.8 36.1002 30.8Z",
    fill: "white"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49961 31.5998C2.72052 31.5998 2.89961 31.4207 2.89961 31.1998C2.89961 30.9789 2.72052 30.7998 2.49961 30.7998C2.2787 30.7998 2.09961 30.9789 2.09961 31.1998C2.09961 31.4207 2.2787 31.5998 2.49961 31.5998Z",
    fill: "white"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 31.6001V30.8001H4.4998V31.2001C4.4998 31.3062 4.54195 31.4079 4.61696 31.4829C4.69198 31.558 4.79372 31.6001 4.8998 31.6001",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 30.7998H5.29961V31.5998H5.69961C5.8057 31.5998 5.90744 31.5577 5.98245 31.4826C6.05747 31.4076 6.09961 31.3059 6.09961 31.1998",
    fill: "white"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 31.6001V30.8001H7.3002C7.19411 30.8001 7.09237 30.8422 7.01735 30.9173C6.94234 30.9923 6.9002 31.094 6.9002 31.2001C6.9002 31.3062 6.94234 31.4079 7.01735 31.4829C7.09237 31.558 7.19411 31.6001 7.3002 31.6001",
    fill: "white"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 30.7998V31.5998H8.1002C8.20628 31.5998 8.30802 31.5577 8.38304 31.4826C8.45805 31.4076 8.5002 31.3059 8.5002 31.1998C8.5002 31.0937 8.45805 30.992 8.38304 30.917C8.30802 30.8419 8.20628 30.7998 8.1002 30.7998",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0998 30.7998H9.2998V31.5998H10.0998V30.7998Z",
    fill: "white"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 30.7998H11.7002V31.5998H12.5002V30.7998Z",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 30.7998H12.5V31.5998H13.3V30.7998Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 30.7998V31.5998H13.6998C13.8059 31.5998 13.9076 31.5577 13.9826 31.4826C14.0577 31.4076 14.0998 31.3059 14.0998 31.1998C14.0998 31.0937 14.0577 30.992 13.9826 30.917C13.9076 30.8419 13.8059 30.7998 13.6998 30.7998",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 31.6001H17.3V31.2001C17.3 31.094 17.2579 30.9923 17.1828 30.9173C17.1078 30.8422 17.0061 30.8001 16.9 30.8001C16.7939 30.8001 16.6922 30.8422 16.6172 30.9173C16.5421 30.9923 16.5 31.094 16.5 31.2001",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0996 31.6001H18.8996V30.8001H18.4996C18.3935 30.8001 18.2918 30.8422 18.2168 30.9173C18.1418 30.9923 18.0996 31.094 18.0996 31.2001",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7004 30.7998H18.9004V31.5998H19.7004V30.7998Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 30.7998H19.7002V31.5998H20.5002V30.7998Z",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 30.7998H20.5V31.5998H21.3V30.7998Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 30.7998H21.2998V31.5998H22.0998V30.7998Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8996 30.7998H22.0996V31.5998H22.8996V30.7998Z",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7004 30.7998H22.9004V31.5998H23.7004V30.7998Z",
    fill: "white"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 30.7998H23.7002V31.5998H24.5002V30.7998Z",
    fill: "white"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 30.7998H24.4998V31.5998H24.8998C25.0059 31.5998 25.1076 31.5577 25.1826 31.4826C25.2577 31.4076 25.2998 31.3059 25.2998 31.1998",
    fill: "white"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 31.6001V30.8001H26.5004C26.3943 30.8001 26.2926 30.8422 26.2175 30.9173C26.1425 30.9923 26.1004 31.094 26.1004 31.2001C26.1004 31.3062 26.1425 31.4079 26.2175 31.4829C26.2926 31.558 26.3943 31.6001 26.5004 31.6001",
    fill: "white"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 30.7998H26.9004V31.5998H27.7004V30.7998Z",
    fill: "white"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 30.7998H27.7002V31.5998H28.5002V30.7998Z",
    fill: "white"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 30.7998V31.5998H29.3V31.1998C29.3 31.0937 29.2579 30.992 29.1828 30.917C29.1078 30.8419 29.0061 30.7998 28.9 30.7998",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 31.6001H30.8996V30.8001H30.4996C30.3935 30.8001 30.2918 30.8422 30.2168 30.9173C30.1418 30.9923 30.0996 31.094 30.0996 31.2001",
    fill: "white"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 30.7998H30.9004V31.5998H31.7004V30.7998Z",
    fill: "white"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 30.7998H31.7002V31.5998H32.5002V30.7998Z",
    fill: "white"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 30.7998H32.5V31.5998H33.3V30.7998Z",
    fill: "white"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 30.7998H33.2998V31.5998H34.0998V30.7998Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 30.7998H34.0996V31.5998H34.8996V30.7998Z",
    fill: "white"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 30.7998V31.5998H35.7004V31.1998C35.7004 31.0937 35.6582 30.992 35.5832 30.917C35.5082 30.8419 35.4065 30.7998 35.3004 30.7998",
    fill: "white"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 31.6001V30.8001H36.8998C36.7937 30.8001 36.692 30.8422 36.617 30.9173C36.5419 30.9923 36.4998 31.094 36.4998 31.2001C36.4998 31.3062 36.5419 31.4079 36.617 31.4829C36.692 31.558 36.7937 31.6001 36.8998 31.6001",
    fill: "white"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 30.7998V31.5998H37.6998C37.8059 31.5998 37.9076 31.5577 37.9826 31.4826C38.0577 31.4076 38.0998 31.3059 38.0998 31.1998C38.0998 31.0937 38.0577 30.992 37.9826 30.917C37.9076 30.8419 37.8059 30.7998 37.6998 30.7998",
    fill: "white"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 32.3999H9.3V31.5999H8.9C8.79391 31.5999 8.69217 31.642 8.61716 31.7171C8.54214 31.7921 8.5 31.8938 8.5 31.9999",
    fill: "white"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 31.6001H9.29961V32.4001H9.69961C9.8057 32.4001 9.90744 32.358 9.98245 32.2829C10.0575 32.2079 10.0996 32.1062 10.0996 32.0001",
    fill: "white"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 31.6001H11.7V32.0001C11.7 32.1062 11.7421 32.2079 11.8172 32.2829C11.8922 32.358 11.9939 32.4001 12.1 32.4001C12.2061 32.4001 12.3078 32.358 12.3828 32.2829C12.4579 32.2079 12.5 32.1062 12.5 32.0001",
    fill: "white"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3004 32.4001C15.5213 32.4001 15.7004 32.221 15.7004 32.0001C15.7004 31.7792 15.5213 31.6001 15.3004 31.6001C15.0795 31.6001 14.9004 31.7792 14.9004 32.0001C14.9004 32.221 15.0795 32.4001 15.3004 32.4001Z",
    fill: "white"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 32.3999V31.5999H16.4998V31.9999C16.4998 32.106 16.5419 32.2077 16.617 32.2827C16.692 32.3578 16.7937 32.3999 16.8998 32.3999",
    fill: "white"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0998 31.6001H17.2998V32.4001H18.0998V31.6001Z",
    fill: "white"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 31.6001H18.0996V32.4001H18.8996V31.6001Z",
    fill: "white"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 31.6001H21.2998V32.4001H22.0998V31.6001Z",
    fill: "white"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 32.3999V31.5999H22.9002V31.9999C22.9002 32.106 22.9423 32.2077 23.0174 32.2827C23.0924 32.3578 23.1941 32.3999 23.3002 32.3999",
    fill: "white"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 31.6001H23.7V32.4001H24.1C24.2061 32.4001 24.3078 32.358 24.3828 32.2829C24.4579 32.2079 24.5 32.1062 24.5 32.0001",
    fill: "white"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6998 32.4001C25.9207 32.4001 26.0998 32.221 26.0998 32.0001C26.0998 31.7792 25.9207 31.6001 25.6998 31.6001C25.4789 31.6001 25.2998 31.7792 25.2998 32.0001C25.2998 32.221 25.4789 32.4001 25.6998 32.4001Z",
    fill: "white"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 32.3999V31.5999H27.7V31.9999C27.7 32.106 27.7421 32.2077 27.8172 32.2827C27.8922 32.3578 27.9939 32.3999 28.1 32.3999",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 31.6001H28.4998V32.4001H28.8998C29.0059 32.4001 29.1076 32.358 29.1826 32.2829C29.2577 32.2079 29.2998 32.1062 29.2998 32.0001",
    fill: "white"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 31.6001H30.0996V32.4001H30.8996V31.6001Z",
    fill: "white"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 31.6001H30.9004V32.4001H31.7004V31.6001Z",
    fill: "white"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 31.6001H34.0996V32.4001H34.8996V31.6001Z",
    fill: "white"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 31.6001H34.9004V32.4001H35.7004V31.6001Z",
    fill: "white"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 31.6001V32.4001H36.5002V32.0001C36.5002 31.894 36.4581 31.7923 36.383 31.7173C36.308 31.6422 36.2063 31.6001 36.1002 31.6001",
    fill: "white"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 32.3999H8.4998V32.7999C8.4998 32.906 8.54195 33.0077 8.61696 33.0827C8.69198 33.1578 8.79372 33.1999 8.8998 33.1999C9.00589 33.1999 9.10763 33.1578 9.18265 33.0827C9.25766 33.0077 9.2998 32.906 9.2998 32.7999",
    fill: "white"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0996 33.2002H10.8996V32.4002H10.4996C10.3935 32.4002 10.2918 32.4423 10.2168 32.5174C10.1418 32.5924 10.0996 32.6941 10.0996 32.8002",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 32.3999V33.1999H11.7004V32.7999C11.7004 32.6938 11.6582 32.5921 11.5832 32.5171C11.5082 32.442 11.4065 32.3999 11.3004 32.3999",
    fill: "white"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 33.2002V32.4002H12.8998C12.7937 32.4002 12.692 32.4423 12.617 32.5174C12.5419 32.5924 12.4998 32.6941 12.4998 32.8002C12.4998 32.9063 12.5419 33.008 12.617 33.083C12.692 33.1581 12.7937 33.2002 12.8998 33.2002",
    fill: "white"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 32.3999V33.1999H13.6998C13.8059 33.1999 13.9076 33.1578 13.9826 33.0827C14.0577 33.0077 14.0998 32.906 14.0998 32.7999C14.0998 32.6938 14.0577 32.5921 13.9826 32.5171C13.9076 32.442 13.8059 32.3999 13.6998 32.3999",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 33.2002H16.5002V32.8002C16.5002 32.6941 16.4581 32.5924 16.383 32.5174C16.308 32.4423 16.2063 32.4002 16.1002 32.4002C15.9941 32.4002 15.8924 32.4423 15.8174 32.5174C15.7423 32.5924 15.7002 32.6941 15.7002 32.8002",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 32.3999H18.0996V33.1999H18.8996V32.3999Z",
    fill: "white"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1002 33.1999C20.3211 33.1999 20.5002 33.0208 20.5002 32.7999C20.5002 32.579 20.3211 32.3999 20.1002 32.3999C19.8793 32.3999 19.7002 32.579 19.7002 32.7999C19.7002 33.0208 19.8793 33.1999 20.1002 33.1999Z",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 32.3999H21.2998V33.1999H22.0998V32.3999Z",
    fill: "white"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 33.2002V32.4002H26.5004C26.3943 32.4002 26.2926 32.4423 26.2175 32.5174C26.1425 32.5924 26.1004 32.6941 26.1004 32.8002C26.1004 32.9063 26.1425 33.008 26.2175 33.083C26.2926 33.1581 26.3943 33.2002 26.5004 33.2002",
    fill: "white"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 32.3999V33.1999H27.3004C27.4065 33.1999 27.5082 33.1578 27.5832 33.0827C27.6582 33.0077 27.7004 32.906 27.7004 32.7999C27.7004 32.6938 27.6582 32.5921 27.5832 32.5171C27.5082 32.442 27.4065 32.3999 27.3004 32.3999",
    fill: "white"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 33.2002H30.0998V32.4002H29.6998C29.5937 32.4002 29.492 32.4423 29.417 32.5174C29.3419 32.5924 29.2998 32.6941 29.2998 32.8002",
    fill: "white"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8996 32.3999H30.0996V33.1999H30.8996V32.3999Z",
    fill: "white"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 32.3999H30.9004V33.1999H31.7004V32.3999Z",
    fill: "white"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 33.1999C33.1209 33.1999 33.3 33.0208 33.3 32.7999C33.3 32.579 33.1209 32.3999 32.9 32.3999C32.6791 32.3999 32.5 32.579 32.5 32.7999C32.5 33.0208 32.6791 33.1999 32.9 33.1999Z",
    fill: "white"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 32.3999H34.0996V33.1999H34.8996V32.3999Z",
    fill: "white"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 32.3999H34.9004V33.1999H35.7004V32.3999Z",
    fill: "white"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5002 32.3999H35.7002V33.1999H36.5002V32.3999Z",
    fill: "white"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 32.3999V33.1999H36.9C37.0061 33.1999 37.1078 33.1578 37.1828 33.0827C37.2579 33.0077 37.3 32.906 37.3 32.7999C37.3 32.6938 37.2579 32.5921 37.1828 32.5171C37.1078 32.442 37.0061 32.3999 36.9 32.3999",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 33.2002H10.0996V34.0002H10.8996V33.2002Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 33.2002H10.9002V34.0002H11.3002C11.4063 34.0002 11.508 33.9581 11.583 33.883C11.6581 33.808 11.7002 33.7063 11.7002 33.6002",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 34V33.2H14.5004C14.3943 33.2 14.2926 33.2421 14.2175 33.3172C14.1425 33.3922 14.1004 33.4939 14.1004 33.6C14.1004 33.7061 14.1425 33.8078 14.2175 33.8828C14.2926 33.9579 14.3943 34 14.5004 34",
    fill: "white"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 33.2002H14.9004V34.0002H15.7004V33.2002Z",
    fill: "white"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 33.2002H15.7002V34.0002H16.5002V33.2002Z",
    fill: "white"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33.2002V34.0002H16.9C17.0061 34.0002 17.1078 33.9581 17.1828 33.883C17.2579 33.808 17.3 33.7063 17.3 33.6002C17.3 33.4941 17.2579 33.3924 17.1828 33.3174C17.1078 33.2423 17.0061 33.2002 16.9 33.2002",
    fill: "white"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 33.2002H18.0996V34.0002H18.8996V33.2002Z",
    fill: "white"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 33.2002H21.2998V34.0002H22.0998V33.2002Z",
    fill: "white"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7002 34V33.2H23.3002C23.1941 33.2 23.0924 33.2421 23.0174 33.3172C22.9423 33.3922 22.9002 33.4939 22.9002 33.6C22.9002 33.7061 22.9423 33.8078 23.0174 33.8828C23.0924 33.9579 23.1941 34 23.3002 34",
    fill: "white"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5002 33.2002H23.7002V34.0002H24.5002V33.2002Z",
    fill: "white"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 33.2002H24.5V34.0002H25.3V33.2002Z",
    fill: "white"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 33.2002V34.0002H26.0998V33.6002C26.0998 33.4941 26.0577 33.3924 25.9826 33.3174C25.9076 33.2423 25.8059 33.2002 25.6998 33.2002",
    fill: "white"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 33.2002H29.2996V33.6002C29.2996 33.7063 29.3418 33.808 29.4168 33.883C29.4918 33.9581 29.5935 34.0002 29.6996 34.0002C29.8057 34.0002 29.9074 33.9581 29.9825 33.883C30.0575 33.808 30.0996 33.7063 30.0996 33.6002",
    fill: "white"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 33.2002H30.9004V34.0002H31.7004V33.2002Z",
    fill: "white"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 33.2002H34.0996V34.0002H34.8996V33.2002Z",
    fill: "white"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 33.2002H35.7V33.6002C35.7 33.7063 35.7421 33.808 35.8172 33.883C35.8922 33.9581 35.9939 34.0002 36.1 34.0002C36.2061 34.0002 36.3078 33.9581 36.3828 33.883C36.4579 33.808 36.5 33.7063 36.5 33.6002",
    fill: "white"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 34.7998H9.3V34.3998C9.3 34.2937 9.25786 34.192 9.18284 34.117C9.10783 34.0419 9.00609 33.9998 8.9 33.9998C8.79391 33.9998 8.69217 34.0419 8.61716 34.117C8.54214 34.192 8.5 34.2937 8.5 34.3998",
    fill: "white"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 34H10.0996V34.8H10.8996V34Z",
    fill: "white"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 34.8C13.1209 34.8 13.3 34.6209 13.3 34.4C13.3 34.1791 13.1209 34 12.9 34C12.6791 34 12.5 34.1791 12.5 34.4C12.5 34.6209 12.6791 34.8 12.9 34.8Z",
    fill: "white"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 34H15.7002V34.8H16.5002V34Z",
    fill: "white"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 34.7998H18.0998V33.9998H17.6998C17.5937 33.9998 17.492 34.0419 17.417 34.117C17.3419 34.192 17.2998 34.2937 17.2998 34.3998",
    fill: "white"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 34H18.0996V34.8H18.8996V34Z",
    fill: "white"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7004 34H18.9004V34.8H19.7004V34Z",
    fill: "white"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 34H19.7002V34.8H20.5002V34Z",
    fill: "white"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 34H20.5V34.8H21.3V34Z",
    fill: "white"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 34H21.2996V34.8H21.6996C21.8057 34.8 21.9074 34.7579 21.9825 34.6828C22.0575 34.6078 22.0996 34.5061 22.0996 34.4",
    fill: "white"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0998 34H25.2998V34.8H26.0998V34Z",
    fill: "white"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7002 34.7998H28.5002V34.3998C28.5002 34.2937 28.4581 34.192 28.383 34.117C28.308 34.0419 28.2063 33.9998 28.1002 33.9998C27.9941 33.9998 27.8924 34.0419 27.8174 34.117C27.7423 34.192 27.7002 34.2937 27.7002 34.3998",
    fill: "white"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 34.7998H30.8996V33.9998H30.4996C30.3935 33.9998 30.2918 34.0419 30.2168 34.117C30.1418 34.192 30.0996 34.2937 30.0996 34.3998",
    fill: "white"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7004 34H30.9004V34.8H31.7004V34Z",
    fill: "white"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 34H31.7002V34.8H32.5002V34Z",
    fill: "white"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 34H32.5V34.8H33.3V34Z",
    fill: "white"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 34H33.2998V34.8H34.0998V34Z",
    fill: "white"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 34H34.0996V34.8H34.8996V34Z",
    fill: "white"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 34V34.8H35.7004V34.4C35.7004 34.2939 35.6582 34.1922 35.5832 34.1172C35.5082 34.0421 35.4065 34 35.3004 34",
    fill: "white"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 34.7998H38.0998V34.3998C38.0998 34.2937 38.0577 34.192 37.9826 34.117C37.9076 34.0419 37.8059 33.9998 37.6998 33.9998C37.5937 33.9998 37.492 34.0419 37.417 34.117C37.3419 34.192 37.2998 34.2937 37.2998 34.3998",
    fill: "white"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 34.7998H8.4998V35.1998C8.4998 35.3059 8.54195 35.4076 8.61696 35.4826C8.69198 35.5577 8.79372 35.5998 8.8998 35.5998C9.00589 35.5998 9.10763 35.5577 9.18265 35.4826C9.25766 35.4076 9.2998 35.3059 9.2998 35.1998",
    fill: "white"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 34.7998H10.0996V35.5998H10.8996V34.7998Z",
    fill: "white"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1002 35.5998C12.3211 35.5998 12.5002 35.4207 12.5002 35.1998C12.5002 34.9789 12.3211 34.7998 12.1002 34.7998C11.8793 34.7998 11.7002 34.9789 11.7002 35.1998C11.7002 35.4207 11.8793 35.5998 12.1002 35.5998Z",
    fill: "white"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6998 35.5998C13.9207 35.5998 14.0998 35.4207 14.0998 35.1998C14.0998 34.9789 13.9207 34.7998 13.6998 34.7998C13.4789 34.7998 13.2998 34.9789 13.2998 35.1998C13.2998 35.4207 13.4789 35.5998 13.6998 35.5998Z",
    fill: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 35.6001H15.7004V34.8001H15.3004C15.1943 34.8001 15.0926 34.8422 15.0175 34.9173C14.9425 34.9923 14.9004 35.094 14.9004 35.2001",
    fill: "white"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 34.7998H15.7V35.5998H16.1C16.2061 35.5998 16.3078 35.5577 16.3828 35.4826C16.4579 35.4076 16.5 35.3059 16.5 35.1998",
    fill: "white"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0996 34.7998H17.2996V35.1998C17.2996 35.3059 17.3418 35.4076 17.4168 35.4826C17.4918 35.5577 17.5935 35.5998 17.6996 35.5998C17.8057 35.5998 17.9074 35.5577 17.9825 35.4826C18.0575 35.4076 18.0996 35.3059 18.0996 35.1998",
    fill: "white"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 34.7998H20.5V35.5998H21.3V34.7998Z",
    fill: "white"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 35.6001V34.8001H24.8998C24.7937 34.8001 24.692 34.8422 24.617 34.9173C24.5419 34.9923 24.4998 35.094 24.4998 35.2001C24.4998 35.3062 24.5419 35.4079 24.617 35.4829C24.692 35.558 24.7937 35.6001 24.8998 35.6001",
    fill: "white"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 34.7998H25.2996V35.5998H25.6996C25.8057 35.5998 25.9074 35.5577 25.9825 35.4826C26.0575 35.4076 26.0996 35.3059 26.0996 35.1998",
    fill: "white"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 34.7998H27.7002V35.5998H28.5002V34.7998Z",
    fill: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 35.6001H30.0998V34.8001H29.6998C29.5937 34.8001 29.492 34.8422 29.417 34.9173C29.3419 34.9923 29.2998 35.094 29.2998 35.2001",
    fill: "white"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9004 34.7998H30.1004V35.5998H30.5004C30.6065 35.5998 30.7082 35.5577 30.7832 35.4826C30.8582 35.4076 30.9004 35.3059 30.9004 35.1998",
    fill: "white"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2998 35.6001V34.8001H32.4998V35.2001C32.4998 35.3062 32.5419 35.4079 32.617 35.4829C32.692 35.558 32.7937 35.6001 32.8998 35.6001",
    fill: "white"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 34.7998H33.2998V35.5998H34.0998V34.7998Z",
    fill: "white"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8996 34.7998H34.0996V35.5998H34.8996V34.7998Z",
    fill: "white"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 34.7998H34.9002V35.5998H35.3002C35.4063 35.5998 35.508 35.5577 35.583 35.4826C35.6581 35.4076 35.7002 35.3059 35.7002 35.1998",
    fill: "white"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0998 34.7998H37.2998V35.5998H38.0998V34.7998Z",
    fill: "white"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 35.6001H10.0996V36.4001H10.8996V35.6001Z",
    fill: "white"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 35.6001V36.4001H11.3004C11.4065 36.4001 11.5082 36.358 11.5832 36.2829C11.6582 36.2079 11.7004 36.1062 11.7004 36.0001C11.7004 35.894 11.6582 35.7923 11.5832 35.7173C11.5082 35.6422 11.4065 35.6001 11.3004 35.6001",
    fill: "white"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 35.6001H14.9004V36.4001H15.7004V35.6001Z",
    fill: "white"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 36.3999H17.3V35.9999C17.3 35.8938 17.2579 35.7921 17.1828 35.7171C17.1078 35.642 17.0061 35.5999 16.9 35.5999C16.7939 35.5999 16.6922 35.642 16.6172 35.7171C16.5421 35.7921 16.5 35.8938 16.5 35.9999",
    fill: "white"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 36.3999H19.7004V35.5999H19.3004C19.1943 35.5999 19.0926 35.642 19.0175 35.7171C18.9425 35.7921 18.9004 35.8938 18.9004 35.9999",
    fill: "white"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5002 35.6001H19.7002V36.4001H20.5002V35.6001Z",
    fill: "white"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 35.6001H20.5V36.4001H21.3V35.6001Z",
    fill: "white"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 35.6001H21.2998V36.4001H22.0998V35.6001Z",
    fill: "white"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 35.6001V36.4001H22.4996C22.6057 36.4001 22.7074 36.358 22.7825 36.2829C22.8575 36.2079 22.8996 36.1062 22.8996 36.0001C22.8996 35.894 22.8575 35.7923 22.7825 35.7173C22.7074 35.6422 22.6057 35.6001 22.4996 35.6001",
    fill: "white"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 36.3999H26.8996V35.9999C26.8996 35.8938 26.8575 35.7921 26.7825 35.7171C26.7074 35.642 26.6057 35.5999 26.4996 35.5999C26.3935 35.5999 26.2918 35.642 26.2168 35.7171C26.1418 35.7921 26.0996 35.8938 26.0996 35.9999",
    fill: "white"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 35.6001H27.7002V36.4001H28.5002V35.6001Z",
    fill: "white"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0998 35.6001H29.2998V36.4001H30.0998V35.6001Z",
    fill: "white"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 36.3999V35.5999H31.3002C31.1941 35.5999 31.0924 35.642 31.0174 35.7171C30.9423 35.7921 30.9002 35.8938 30.9002 35.9999C30.9002 36.106 30.9423 36.2077 31.0174 36.2827C31.0924 36.3578 31.1941 36.3999 31.3002 36.3999",
    fill: "white"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 35.6001V36.4001H32.5002V36.0001C32.5002 35.894 32.4581 35.7923 32.383 35.7173C32.308 35.6422 32.2063 35.6001 32.1002 35.6001",
    fill: "white"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 35.6001H33.2998V36.4001H34.0998V35.6001Z",
    fill: "white"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9004 35.6001H34.1004V36.4001H34.5004C34.6065 36.4001 34.7082 36.358 34.7832 36.2829C34.8582 36.2079 34.9004 36.1062 34.9004 36.0001",
    fill: "white"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7002 36.3999H36.5002V35.5999H36.1002C35.9941 35.5999 35.8924 35.642 35.8174 35.7171C35.7423 35.7921 35.7002 35.8938 35.7002 35.9999",
    fill: "white"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 35.6001H36.5V36.4001H37.3V35.6001Z",
    fill: "white"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0998 35.6001H37.2998V36.4001H38.0998V35.6001Z",
    fill: "white"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9004 36.3999H10.1004V36.7999C10.1004 36.906 10.1425 37.0077 10.2175 37.0827C10.2926 37.1578 10.3943 37.1999 10.5004 37.1999C10.6065 37.1999 10.7082 37.1578 10.7832 37.0827C10.8582 37.0077 10.9004 36.906 10.9004 36.7999",
    fill: "white"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 37.2002H13.3V36.4002H12.9C12.7939 36.4002 12.6922 36.4423 12.6172 36.5174C12.5421 36.5924 12.5 36.6941 12.5 36.8002",
    fill: "white"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 36.3999V37.1999H13.6998C13.8059 37.1999 13.9076 37.1578 13.9826 37.0827C14.0577 37.0077 14.0998 36.906 14.0998 36.7999C14.0998 36.6938 14.0577 36.5921 13.9826 36.5171C13.9076 36.442 13.8059 36.3999 13.6998 36.3999",
    fill: "white"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 37.2002V36.4002H14.9002V36.8002C14.9002 36.9063 14.9423 37.008 15.0174 37.083C15.0924 37.1581 15.1941 37.2002 15.3002 37.2002",
    fill: "white"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 36.3999H15.7002V37.1999H16.5002V36.3999Z",
    fill: "white"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 36.3999H16.5V37.1999H17.3V36.3999Z",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0998 36.3999H17.2998V37.1999H18.0998V36.3999Z",
    fill: "white"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 36.3999H18.0996V37.1999H18.8996V36.3999Z",
    fill: "white"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7004 36.3999H18.9004V37.1999H19.7004V36.3999Z",
    fill: "white"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 36.3999H19.7V37.1999H20.1C20.2061 37.1999 20.3078 37.1578 20.3828 37.0827C20.4579 37.0077 20.5 36.906 20.5 36.7999",
    fill: "white"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0998 36.3999H21.2998V37.1999H22.0998V36.3999Z",
    fill: "white"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3004 37.1999C23.5213 37.1999 23.7004 37.0208 23.7004 36.7999C23.7004 36.579 23.5213 36.3999 23.3004 36.3999C23.0795 36.3999 22.9004 36.579 22.9004 36.7999C22.9004 37.0208 23.0795 37.1999 23.3004 37.1999Z",
    fill: "white"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9 37.1999C25.1209 37.1999 25.3 37.0208 25.3 36.7999C25.3 36.579 25.1209 36.3999 24.9 36.3999C24.6791 36.3999 24.5 36.579 24.5 36.7999C24.5 37.0208 24.6791 37.1999 24.9 37.1999Z",
    fill: "white"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8996 36.3999H26.0996V37.1999H26.8996V36.3999Z",
    fill: "white"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7004 36.3999H26.9004V37.1999H27.7004V36.3999Z",
    fill: "white"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5002 36.3999H27.7002V37.1999H28.5002V36.3999Z",
    fill: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 36.3999H28.5V37.1999H29.3V36.3999Z",
    fill: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0996 36.3999H29.2996V37.1999H29.6996C29.8057 37.1999 29.9074 37.1578 29.9825 37.0827C30.0575 37.0077 30.0996 36.906 30.0996 36.7999",
    fill: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 36.3999H31.7002V37.1999H32.5002V36.3999Z",
    fill: "white"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 36.3999H32.5V37.1999H33.3V36.3999Z",
    fill: "white"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 36.3999H33.2998V37.1999H34.0998V36.3999Z",
    fill: "white"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 37.2002V36.4002H35.7V36.8002C35.7 36.9063 35.7421 37.008 35.8172 37.083C35.8922 37.1581 35.9939 37.2002 36.1 37.2002",
    fill: "white"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 36.3999H36.5V37.1999H37.3V36.3999Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0996 36.3999H37.2996V37.1999H37.6996C37.8057 37.1999 37.9074 37.1578 37.9825 37.0827C38.0575 37.0077 38.0996 36.906 38.0996 36.7999",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 37.2002H12.4998V37.6002C12.4998 37.7063 12.5419 37.808 12.617 37.883C12.692 37.9581 12.7937 38.0002 12.8998 38.0002C13.0059 38.0002 13.1076 37.9581 13.1826 37.883C13.2577 37.808 13.2998 37.7063 13.2998 37.6002",
    fill: "white"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4996 38.0002C14.7205 38.0002 14.8996 37.8211 14.8996 37.6002C14.8996 37.3793 14.7205 37.2002 14.4996 37.2002C14.2787 37.2002 14.0996 37.3793 14.0996 37.6002C14.0996 37.8211 14.2787 38.0002 14.4996 38.0002Z",
    fill: "white"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 38V37.2H15.7V37.6C15.7 37.7061 15.7421 37.8078 15.8172 37.8828C15.8922 37.9579 15.9939 38 16.1 38",
    fill: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 37.2002H16.4998V38.0002H16.8998C17.0059 38.0002 17.1076 37.9581 17.1826 37.883C17.2577 37.808 17.2998 37.7063 17.2998 37.6002",
    fill: "white"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9004 38V37.2H18.1004V37.6C18.1004 37.7061 18.1425 37.8078 18.2175 37.8828C18.2926 37.9579 18.3943 38 18.5004 38",
    fill: "white"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7002 37.2002H18.9002V38.0002H19.3002C19.4063 38.0002 19.508 37.9581 19.583 37.883C19.6581 37.808 19.7002 37.7063 19.7002 37.6002",
    fill: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 38V37.2H21.2996V37.6C21.2996 37.7061 21.3418 37.8078 21.4168 37.8828C21.4918 37.9579 21.5935 38 21.6996 38",
    fill: "white"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 37.2002V38.0002H22.4996C22.6057 38.0002 22.7074 37.9581 22.7825 37.883C22.8575 37.808 22.8996 37.7063 22.8996 37.6002C22.8996 37.4941 22.8575 37.3924 22.7825 37.3174C22.7074 37.2423 22.6057 37.2002 22.4996 37.2002",
    fill: "white"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 38V37.2H25.6996C25.5935 37.2 25.4918 37.2421 25.4168 37.3172C25.3418 37.3922 25.2996 37.4939 25.2996 37.6C25.2996 37.7061 25.3418 37.8078 25.4168 37.8828C25.4918 37.9579 25.5935 38 25.6996 38",
    fill: "white"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9004 37.2002H26.1004V38.0002H26.5004C26.6065 38.0002 26.7082 37.9581 26.7832 37.883C26.8582 37.808 26.9004 37.7063 26.9004 37.6002",
    fill: "white"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 38V37.2H27.7V37.6C27.7 37.7061 27.7421 37.8078 27.8172 37.8828C27.8922 37.9579 27.9939 38 28.1 38",
    fill: "white"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2998 37.2002H28.4998V38.0002H28.8998C29.0059 38.0002 29.1076 37.9581 29.1826 37.883C29.2577 37.808 29.2998 37.7063 29.2998 37.6002",
    fill: "white"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7002 38V37.2H31.3002C31.1941 37.2 31.0924 37.2421 31.0174 37.3172C30.9423 37.3922 30.9002 37.4939 30.9002 37.6C30.9002 37.7061 30.9423 37.8078 31.0174 37.8828C31.0924 37.9579 31.1941 38 31.3002 38",
    fill: "white"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5002 37.2002H31.7002V38.0002H32.5002V37.2002Z",
    fill: "white"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 37.2002H32.5V38.0002H33.3V37.2002Z",
    fill: "white"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0998 37.2002H33.2998V38.0002H34.0998V37.2002Z",
    fill: "white"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0996 37.2002V38.0002H34.4996C34.6057 38.0002 34.7074 37.9581 34.7825 37.883C34.8575 37.808 34.8996 37.7063 34.8996 37.6002C34.8996 37.4941 34.8575 37.3924 34.7825 37.3174C34.7074 37.2423 34.6057 37.2002 34.4996 37.2002",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2624_41551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0996 0H0.0996094V40H40.0996V0Z",
    fill: "#D4AF36"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2624_41551",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2624_41551",
    transform: "scale(0.0144928)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2624_41551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.0996094)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2624_41551",
    width: 69,
    height: 69,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABFCAYAAAAcjSspAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIuSURBVHgB7ZqBUQIxEEW/jgXYgWsFWgIdaAfYgVoB14FYAZRgB4wdSAVcB2IFmAzHwEgSwiaXO/C/mR0g4ZLw2exdkgUIIYQQQgg5ZS5QDmnMxZexJf4hlbGVxwQ94hJkD4rigKI4uEJero09Yh0jbprP102dIJ0XYw/NexuYa2Ofxj7QQ8TYxNg3/ME0ZBLZz9Rz/cLYCD3CeoZWjFyi7Ioj6Jgh0sTILUrnwgjSPaQNUazNkEDK3WeCbRDtGwOsg3JR7hHvBdabFgh7lcR1i3FEW7v9FmWM8JweYN+LKqSLsoscaHPVjKMYMxz/AyvFNTGE/iDVFNLGFF8ssavdGmWpAnV3UKAVRTzlXSz/s/eZ21POgtwLwhpnAFfJDrSr5NpT/oNuqD3lqvFoRblFv8g6Hk4fBxTFAUVxQFEcUBQHFMUBRXGgfU4RT/kS3SwKxVNedDy+/YtJ4JoK7eynaMfjhdPHAUVxkFsUwRmgFaX2lJ/F5pNWFF9EF5TnPlCn2jrQijL3lFtPGaEsb4G6Ggq0zyl2137oqauw9ph5870NN0hHsPVG+/qMsKcUTdGwHrHKaBLXbfRZctJ5ckpMeUe/eUUHWG9ZoJ+eUqFDBHmEkcj+phFtTdEDBMfN9TZFKZ5+cYgnhA/e2xLFplyMkfEZqa00dHubtDFHdspsVuOj5/v2iKLGYQZ/2twc6J9sCnuFdE8pAlfJDiiKg9wZ1yE2GdKEEEIIIYQQUppf2ax6+KyTGoEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElegantGoldQr);
export default __webpack_public_path__ + "static/media/elegant-gold-qr.0aca08cd48e44ee9ca35804e14622563.svg";
export { ForwardRef as ReactComponent };